export default {
  name: 'bootstrap-icons',
  icons: [
    { name: 'bi', tags: [] },
    { name: 'bi-123', tags: [] },
    { name: 'bi-alarm-fill', tags: [] },
    { name: 'bi-alarm', tags: [] },
    { name: 'bi-align-bottom', tags: [] },
    { name: 'bi-align-center', tags: [] },
    { name: 'bi-align-end', tags: [] },
    { name: 'bi-align-middle', tags: [] },
    { name: 'bi-align-start', tags: [] },
    { name: 'bi-align-top', tags: [] },
    { name: 'bi-alt', tags: [] },
    { name: 'bi-app-indicator', tags: [] },
    { name: 'bi-app', tags: [] },
    { name: 'bi-archive-fill', tags: [] },
    { name: 'bi-archive', tags: [] },
    { name: 'bi-arrow-90deg-down', tags: [] },
    { name: 'bi-arrow-90deg-left', tags: [] },
    { name: 'bi-arrow-90deg-right', tags: [] },
    { name: 'bi-arrow-90deg-up', tags: [] },
    { name: 'bi-arrow-bar-down', tags: [] },
    { name: 'bi-arrow-bar-left', tags: [] },
    { name: 'bi-arrow-bar-right', tags: [] },
    { name: 'bi-arrow-bar-up', tags: [] },
    { name: 'bi-arrow-clockwise', tags: [] },
    { name: 'bi-arrow-counterclockwise', tags: [] },
    { name: 'bi-arrow-down-circle-fill', tags: [] },
    { name: 'bi-arrow-down-circle', tags: [] },
    { name: 'bi-arrow-down-left-circle-fill', tags: [] },
    { name: 'bi-arrow-down-left-circle', tags: [] },
    { name: 'bi-arrow-down-left-square-fill', tags: [] },
    { name: 'bi-arrow-down-left-square', tags: [] },
    { name: 'bi-arrow-down-left', tags: [] },
    { name: 'bi-arrow-down-right-circle-fill', tags: [] },
    { name: 'bi-arrow-down-right-circle', tags: [] },
    { name: 'bi-arrow-down-right-square-fill', tags: [] },
    { name: 'bi-arrow-down-right-square', tags: [] },
    { name: 'bi-arrow-down-right', tags: [] },
    { name: 'bi-arrow-down-short', tags: [] },
    { name: 'bi-arrow-down-square-fill', tags: [] },
    { name: 'bi-arrow-down-square', tags: [] },
    { name: 'bi-arrow-down-up', tags: [] },
    { name: 'bi-arrow-down', tags: [] },
    { name: 'bi-arrow-left-circle-fill', tags: [] },
    { name: 'bi-arrow-left-circle', tags: [] },
    { name: 'bi-arrow-left-right', tags: [] },
    { name: 'bi-arrow-left-short', tags: [] },
    { name: 'bi-arrow-left-square-fill', tags: [] },
    { name: 'bi-arrow-left-square', tags: [] },
    { name: 'bi-arrow-left', tags: [] },
    { name: 'bi-arrow-repeat', tags: [] },
    { name: 'bi-arrow-return-left', tags: [] },
    { name: 'bi-arrow-return-right', tags: [] },
    { name: 'bi-arrow-right-circle-fill', tags: [] },
    { name: 'bi-arrow-right-circle', tags: [] },
    { name: 'bi-arrow-right-short', tags: [] },
    { name: 'bi-arrow-right-square-fill', tags: [] },
    { name: 'bi-arrow-right-square', tags: [] },
    { name: 'bi-arrow-right', tags: [] },
    { name: 'bi-arrow-up-circle-fill', tags: [] },
    { name: 'bi-arrow-up-circle', tags: [] },
    { name: 'bi-arrow-up-left-circle-fill', tags: [] },
    { name: 'bi-arrow-up-left-circle', tags: [] },
    { name: 'bi-arrow-up-left-square-fill', tags: [] },
    { name: 'bi-arrow-up-left-square', tags: [] },
    { name: 'bi-arrow-up-left', tags: [] },
    { name: 'bi-arrow-up-right-circle-fill', tags: [] },
    { name: 'bi-arrow-up-right-circle', tags: [] },
    { name: 'bi-arrow-up-right-square-fill', tags: [] },
    { name: 'bi-arrow-up-right-square', tags: [] },
    { name: 'bi-arrow-up-right', tags: [] },
    { name: 'bi-arrow-up-short', tags: [] },
    { name: 'bi-arrow-up-square-fill', tags: [] },
    { name: 'bi-arrow-up-square', tags: [] },
    { name: 'bi-arrow-up', tags: [] },
    { name: 'bi-arrows-angle-contract', tags: [] },
    { name: 'bi-arrows-angle-expand', tags: [] },
    { name: 'bi-arrows-collapse', tags: [] },
    { name: 'bi-arrows-expand', tags: [] },
    { name: 'bi-arrows-fullscreen', tags: [] },
    { name: 'bi-arrows-move', tags: [] },
    { name: 'bi-aspect-ratio-fill', tags: [] },
    { name: 'bi-aspect-ratio', tags: [] },
    { name: 'bi-asterisk', tags: [] },
    { name: 'bi-at', tags: [] },
    { name: 'bi-award-fill', tags: [] },
    { name: 'bi-award', tags: [] },
    { name: 'bi-back', tags: [] },
    { name: 'bi-backspace-fill', tags: [] },
    { name: 'bi-backspace-reverse-fill', tags: [] },
    { name: 'bi-backspace-reverse', tags: [] },
    { name: 'bi-backspace', tags: [] },
    { name: 'bi-badge-3d-fill', tags: [] },
    { name: 'bi-badge-3d', tags: [] },
    { name: 'bi-badge-4k-fill', tags: [] },
    { name: 'bi-badge-4k', tags: [] },
    { name: 'bi-badge-8k-fill', tags: [] },
    { name: 'bi-badge-8k', tags: [] },
    { name: 'bi-badge-ad-fill', tags: [] },
    { name: 'bi-badge-ad', tags: [] },
    { name: 'bi-badge-ar-fill', tags: [] },
    { name: 'bi-badge-ar', tags: [] },
    { name: 'bi-badge-cc-fill', tags: [] },
    { name: 'bi-badge-cc', tags: [] },
    { name: 'bi-badge-hd-fill', tags: [] },
    { name: 'bi-badge-hd', tags: [] },
    { name: 'bi-badge-tm-fill', tags: [] },
    { name: 'bi-badge-tm', tags: [] },
    { name: 'bi-badge-vo-fill', tags: [] },
    { name: 'bi-badge-vo', tags: [] },
    { name: 'bi-badge-vr-fill', tags: [] },
    { name: 'bi-badge-vr', tags: [] },
    { name: 'bi-badge-wc-fill', tags: [] },
    { name: 'bi-badge-wc', tags: [] },
    { name: 'bi-bag-check-fill', tags: [] },
    { name: 'bi-bag-check', tags: [] },
    { name: 'bi-bag-dash-fill', tags: [] },
    { name: 'bi-bag-dash', tags: [] },
    { name: 'bi-bag-fill', tags: [] },
    { name: 'bi-bag-plus-fill', tags: [] },
    { name: 'bi-bag-plus', tags: [] },
    { name: 'bi-bag-x-fill', tags: [] },
    { name: 'bi-bag-x', tags: [] },
    { name: 'bi-bag', tags: [] },
    { name: 'bi-bar-chart-fill', tags: [] },
    { name: 'bi-bar-chart-line-fill', tags: [] },
    { name: 'bi-bar-chart-line', tags: [] },
    { name: 'bi-bar-chart-steps', tags: [] },
    { name: 'bi-bar-chart', tags: [] },
    { name: 'bi-basket-fill', tags: [] },
    { name: 'bi-basket', tags: [] },
    { name: 'bi-basket2-fill', tags: [] },
    { name: 'bi-basket2', tags: [] },
    { name: 'bi-basket3-fill', tags: [] },
    { name: 'bi-basket3', tags: [] },
    { name: 'bi-battery-charging', tags: [] },
    { name: 'bi-battery-full', tags: [] },
    { name: 'bi-battery-half', tags: [] },
    { name: 'bi-battery', tags: [] },
    { name: 'bi-bell-fill', tags: [] },
    { name: 'bi-bell', tags: [] },
    { name: 'bi-bezier', tags: [] },
    { name: 'bi-bezier2', tags: [] },
    { name: 'bi-bicycle', tags: [] },
    { name: 'bi-binoculars-fill', tags: [] },
    { name: 'bi-binoculars', tags: [] },
    { name: 'bi-blockquote-left', tags: [] },
    { name: 'bi-blockquote-right', tags: [] },
    { name: 'bi-book-fill', tags: [] },
    { name: 'bi-book-half', tags: [] },
    { name: 'bi-book', tags: [] },
    { name: 'bi-bookmark-check-fill', tags: [] },
    { name: 'bi-bookmark-check', tags: [] },
    { name: 'bi-bookmark-dash-fill', tags: [] },
    { name: 'bi-bookmark-dash', tags: [] },
    { name: 'bi-bookmark-fill', tags: [] },
    { name: 'bi-bookmark-heart-fill', tags: [] },
    { name: 'bi-bookmark-heart', tags: [] },
    { name: 'bi-bookmark-plus-fill', tags: [] },
    { name: 'bi-bookmark-plus', tags: [] },
    { name: 'bi-bookmark-star-fill', tags: [] },
    { name: 'bi-bookmark-star', tags: [] },
    { name: 'bi-bookmark-x-fill', tags: [] },
    { name: 'bi-bookmark-x', tags: [] },
    { name: 'bi-bookmark', tags: [] },
    { name: 'bi-bookmarks-fill', tags: [] },
    { name: 'bi-bookmarks', tags: [] },
    { name: 'bi-bookshelf', tags: [] },
    { name: 'bi-bootstrap-fill', tags: [] },
    { name: 'bi-bootstrap-reboot', tags: [] },
    { name: 'bi-bootstrap', tags: [] },
    { name: 'bi-border-all', tags: [] },
    { name: 'bi-border-bottom', tags: [] },
    { name: 'bi-border-center', tags: [] },
    { name: 'bi-border-inner', tags: [] },
    { name: 'bi-border-left', tags: [] },
    { name: 'bi-border-middle', tags: [] },
    { name: 'bi-border-outer', tags: [] },
    { name: 'bi-border-right', tags: [] },
    { name: 'bi-border-style', tags: [] },
    { name: 'bi-border-top', tags: [] },
    { name: 'bi-border-width', tags: [] },
    { name: 'bi-border', tags: [] },
    { name: 'bi-bounding-box-circles', tags: [] },
    { name: 'bi-bounding-box', tags: [] },
    { name: 'bi-box-arrow-down-left', tags: [] },
    { name: 'bi-box-arrow-down-right', tags: [] },
    { name: 'bi-box-arrow-down', tags: [] },
    { name: 'bi-box-arrow-in-down-left', tags: [] },
    { name: 'bi-box-arrow-in-down-right', tags: [] },
    { name: 'bi-box-arrow-in-down', tags: [] },
    { name: 'bi-box-arrow-in-left', tags: [] },
    { name: 'bi-box-arrow-in-right', tags: [] },
    { name: 'bi-box-arrow-in-up-left', tags: [] },
    { name: 'bi-box-arrow-in-up-right', tags: [] },
    { name: 'bi-box-arrow-in-up', tags: [] },
    { name: 'bi-box-arrow-left', tags: [] },
    { name: 'bi-box-arrow-right', tags: [] },
    { name: 'bi-box-arrow-up-left', tags: [] },
    { name: 'bi-box-arrow-up-right', tags: [] },
    { name: 'bi-box-arrow-up', tags: [] },
    { name: 'bi-box-seam', tags: [] },
    { name: 'bi-box', tags: [] },
    { name: 'bi-braces', tags: [] },
    { name: 'bi-bricks', tags: [] },
    { name: 'bi-briefcase-fill', tags: [] },
    { name: 'bi-briefcase', tags: [] },
    { name: 'bi-brightness-alt-high-fill', tags: [] },
    { name: 'bi-brightness-alt-high', tags: [] },
    { name: 'bi-brightness-alt-low-fill', tags: [] },
    { name: 'bi-brightness-alt-low', tags: [] },
    { name: 'bi-brightness-high-fill', tags: [] },
    { name: 'bi-brightness-high', tags: [] },
    { name: 'bi-brightness-low-fill', tags: [] },
    { name: 'bi-brightness-low', tags: [] },
    { name: 'bi-broadcast-pin', tags: [] },
    { name: 'bi-broadcast', tags: [] },
    { name: 'bi-brush-fill', tags: [] },
    { name: 'bi-brush', tags: [] },
    { name: 'bi-bucket-fill', tags: [] },
    { name: 'bi-bucket', tags: [] },
    { name: 'bi-bug-fill', tags: [] },
    { name: 'bi-bug', tags: [] },
    { name: 'bi-building', tags: [] },
    { name: 'bi-bullseye', tags: [] },
    { name: 'bi-calculator-fill', tags: [] },
    { name: 'bi-calculator', tags: [] },
    { name: 'bi-calendar-check-fill', tags: [] },
    { name: 'bi-calendar-check', tags: [] },
    { name: 'bi-calendar-date-fill', tags: [] },
    { name: 'bi-calendar-date', tags: [] },
    { name: 'bi-calendar-day-fill', tags: [] },
    { name: 'bi-calendar-day', tags: [] },
    { name: 'bi-calendar-event-fill', tags: [] },
    { name: 'bi-calendar-event', tags: [] },
    { name: 'bi-calendar-fill', tags: [] },
    { name: 'bi-calendar-minus-fill', tags: [] },
    { name: 'bi-calendar-minus', tags: [] },
    { name: 'bi-calendar-month-fill', tags: [] },
    { name: 'bi-calendar-month', tags: [] },
    { name: 'bi-calendar-plus-fill', tags: [] },
    { name: 'bi-calendar-plus', tags: [] },
    { name: 'bi-calendar-range-fill', tags: [] },
    { name: 'bi-calendar-range', tags: [] },
    { name: 'bi-calendar-week-fill', tags: [] },
    { name: 'bi-calendar-week', tags: [] },
    { name: 'bi-calendar-x-fill', tags: [] },
    { name: 'bi-calendar-x', tags: [] },
    { name: 'bi-calendar', tags: [] },
    { name: 'bi-calendar2-check-fill', tags: [] },
    { name: 'bi-calendar2-check', tags: [] },
    { name: 'bi-calendar2-date-fill', tags: [] },
    { name: 'bi-calendar2-date', tags: [] },
    { name: 'bi-calendar2-day-fill', tags: [] },
    { name: 'bi-calendar2-day', tags: [] },
    { name: 'bi-calendar2-event-fill', tags: [] },
    { name: 'bi-calendar2-event', tags: [] },
    { name: 'bi-calendar2-fill', tags: [] },
    { name: 'bi-calendar2-minus-fill', tags: [] },
    { name: 'bi-calendar2-minus', tags: [] },
    { name: 'bi-calendar2-month-fill', tags: [] },
    { name: 'bi-calendar2-month', tags: [] },
    { name: 'bi-calendar2-plus-fill', tags: [] },
    { name: 'bi-calendar2-plus', tags: [] },
    { name: 'bi-calendar2-range-fill', tags: [] },
    { name: 'bi-calendar2-range', tags: [] },
    { name: 'bi-calendar2-week-fill', tags: [] },
    { name: 'bi-calendar2-week', tags: [] },
    { name: 'bi-calendar2-x-fill', tags: [] },
    { name: 'bi-calendar2-x', tags: [] },
    { name: 'bi-calendar2', tags: [] },
    { name: 'bi-calendar3-event-fill', tags: [] },
    { name: 'bi-calendar3-event', tags: [] },
    { name: 'bi-calendar3-fill', tags: [] },
    { name: 'bi-calendar3-range-fill', tags: [] },
    { name: 'bi-calendar3-range', tags: [] },
    { name: 'bi-calendar3-week-fill', tags: [] },
    { name: 'bi-calendar3-week', tags: [] },
    { name: 'bi-calendar3', tags: [] },
    { name: 'bi-calendar4-event', tags: [] },
    { name: 'bi-calendar4-range', tags: [] },
    { name: 'bi-calendar4-week', tags: [] },
    { name: 'bi-calendar4', tags: [] },
    { name: 'bi-camera-fill', tags: [] },
    { name: 'bi-camera-reels-fill', tags: [] },
    { name: 'bi-camera-reels', tags: [] },
    { name: 'bi-camera-video-fill', tags: [] },
    { name: 'bi-camera-video-off-fill', tags: [] },
    { name: 'bi-camera-video-off', tags: [] },
    { name: 'bi-camera-video', tags: [] },
    { name: 'bi-camera', tags: [] },
    { name: 'bi-camera2', tags: [] },
    { name: 'bi-capslock-fill', tags: [] },
    { name: 'bi-capslock', tags: [] },
    { name: 'bi-card-checklist', tags: [] },
    { name: 'bi-card-heading', tags: [] },
    { name: 'bi-card-image', tags: [] },
    { name: 'bi-card-list', tags: [] },
    { name: 'bi-card-text', tags: [] },
    { name: 'bi-caret-down-fill', tags: [] },
    { name: 'bi-caret-down-square-fill', tags: [] },
    { name: 'bi-caret-down-square', tags: [] },
    { name: 'bi-caret-down', tags: [] },
    { name: 'bi-caret-left-fill', tags: [] },
    { name: 'bi-caret-left-square-fill', tags: [] },
    { name: 'bi-caret-left-square', tags: [] },
    { name: 'bi-caret-left', tags: [] },
    { name: 'bi-caret-right-fill', tags: [] },
    { name: 'bi-caret-right-square-fill', tags: [] },
    { name: 'bi-caret-right-square', tags: [] },
    { name: 'bi-caret-right', tags: [] },
    { name: 'bi-caret-up-fill', tags: [] },
    { name: 'bi-caret-up-square-fill', tags: [] },
    { name: 'bi-caret-up-square', tags: [] },
    { name: 'bi-caret-up', tags: [] },
    { name: 'bi-cart-check-fill', tags: [] },
    { name: 'bi-cart-check', tags: [] },
    { name: 'bi-cart-dash-fill', tags: [] },
    { name: 'bi-cart-dash', tags: [] },
    { name: 'bi-cart-fill', tags: [] },
    { name: 'bi-cart-plus-fill', tags: [] },
    { name: 'bi-cart-plus', tags: [] },
    { name: 'bi-cart-x-fill', tags: [] },
    { name: 'bi-cart-x', tags: [] },
    { name: 'bi-cart', tags: [] },
    { name: 'bi-cart2', tags: [] },
    { name: 'bi-cart3', tags: [] },
    { name: 'bi-cart4', tags: [] },
    { name: 'bi-cash-stack', tags: [] },
    { name: 'bi-cash', tags: [] },
    { name: 'bi-cast', tags: [] },
    { name: 'bi-chat-dots-fill', tags: [] },
    { name: 'bi-chat-dots', tags: [] },
    { name: 'bi-chat-fill', tags: [] },
    { name: 'bi-chat-left-dots-fill', tags: [] },
    { name: 'bi-chat-left-dots', tags: [] },
    { name: 'bi-chat-left-fill', tags: [] },
    { name: 'bi-chat-left-quote-fill', tags: [] },
    { name: 'bi-chat-left-quote', tags: [] },
    { name: 'bi-chat-left-text-fill', tags: [] },
    { name: 'bi-chat-left-text', tags: [] },
    { name: 'bi-chat-left', tags: [] },
    { name: 'bi-chat-quote-fill', tags: [] },
    { name: 'bi-chat-quote', tags: [] },
    { name: 'bi-chat-right-dots-fill', tags: [] },
    { name: 'bi-chat-right-dots', tags: [] },
    { name: 'bi-chat-right-fill', tags: [] },
    { name: 'bi-chat-right-quote-fill', tags: [] },
    { name: 'bi-chat-right-quote', tags: [] },
    { name: 'bi-chat-right-text-fill', tags: [] },
    { name: 'bi-chat-right-text', tags: [] },
    { name: 'bi-chat-right', tags: [] },
    { name: 'bi-chat-square-dots-fill', tags: [] },
    { name: 'bi-chat-square-dots', tags: [] },
    { name: 'bi-chat-square-fill', tags: [] },
    { name: 'bi-chat-square-quote-fill', tags: [] },
    { name: 'bi-chat-square-quote', tags: [] },
    { name: 'bi-chat-square-text-fill', tags: [] },
    { name: 'bi-chat-square-text', tags: [] },
    { name: 'bi-chat-square', tags: [] },
    { name: 'bi-chat-text-fill', tags: [] },
    { name: 'bi-chat-text', tags: [] },
    { name: 'bi-chat', tags: [] },
    { name: 'bi-check-all', tags: [] },
    { name: 'bi-check-circle-fill', tags: [] },
    { name: 'bi-check-circle', tags: [] },
    { name: 'bi-check-square-fill', tags: [] },
    { name: 'bi-check-square', tags: [] },
    { name: 'bi-check', tags: [] },
    { name: 'bi-check2-all', tags: [] },
    { name: 'bi-check2-circle', tags: [] },
    { name: 'bi-check2-square', tags: [] },
    { name: 'bi-check2', tags: [] },
    { name: 'bi-chevron-bar-contract', tags: [] },
    { name: 'bi-chevron-bar-down', tags: [] },
    { name: 'bi-chevron-bar-expand', tags: [] },
    { name: 'bi-chevron-bar-left', tags: [] },
    { name: 'bi-chevron-bar-right', tags: [] },
    { name: 'bi-chevron-bar-up', tags: [] },
    { name: 'bi-chevron-compact-down', tags: [] },
    { name: 'bi-chevron-compact-left', tags: [] },
    { name: 'bi-chevron-compact-right', tags: [] },
    { name: 'bi-chevron-compact-up', tags: [] },
    { name: 'bi-chevron-contract', tags: [] },
    { name: 'bi-chevron-double-down', tags: [] },
    { name: 'bi-chevron-double-left', tags: [] },
    { name: 'bi-chevron-double-right', tags: [] },
    { name: 'bi-chevron-double-up', tags: [] },
    { name: 'bi-chevron-down', tags: [] },
    { name: 'bi-chevron-expand', tags: [] },
    { name: 'bi-chevron-left', tags: [] },
    { name: 'bi-chevron-right', tags: [] },
    { name: 'bi-chevron-up', tags: [] },
    { name: 'bi-circle-fill', tags: [] },
    { name: 'bi-circle-half', tags: [] },
    { name: 'bi-circle-square', tags: [] },
    { name: 'bi-circle', tags: [] },
    { name: 'bi-clipboard-check', tags: [] },
    { name: 'bi-clipboard-data', tags: [] },
    { name: 'bi-clipboard-minus', tags: [] },
    { name: 'bi-clipboard-plus', tags: [] },
    { name: 'bi-clipboard-x', tags: [] },
    { name: 'bi-clipboard', tags: [] },
    { name: 'bi-clock-fill', tags: [] },
    { name: 'bi-clock-history', tags: [] },
    { name: 'bi-clock', tags: [] },
    { name: 'bi-cloud-arrow-down-fill', tags: [] },
    { name: 'bi-cloud-arrow-down', tags: [] },
    { name: 'bi-cloud-arrow-up-fill', tags: [] },
    { name: 'bi-cloud-arrow-up', tags: [] },
    { name: 'bi-cloud-check-fill', tags: [] },
    { name: 'bi-cloud-check', tags: [] },
    { name: 'bi-cloud-download-fill', tags: [] },
    { name: 'bi-cloud-download', tags: [] },
    { name: 'bi-cloud-drizzle-fill', tags: [] },
    { name: 'bi-cloud-drizzle', tags: [] },
    { name: 'bi-cloud-fill', tags: [] },
    { name: 'bi-cloud-fog-fill', tags: [] },
    { name: 'bi-cloud-fog', tags: [] },
    { name: 'bi-cloud-fog2-fill', tags: [] },
    { name: 'bi-cloud-fog2', tags: [] },
    { name: 'bi-cloud-hail-fill', tags: [] },
    { name: 'bi-cloud-hail', tags: [] },
    { name: 'bi-cloud-haze-fill', tags: [] },
    { name: 'bi-cloud-haze', tags: [] },
    { name: 'bi-cloud-haze2-fill', tags: [] },
    { name: 'bi-cloud-lightning-fill', tags: [] },
    { name: 'bi-cloud-lightning-rain-fill', tags: [] },
    { name: 'bi-cloud-lightning-rain', tags: [] },
    { name: 'bi-cloud-lightning', tags: [] },
    { name: 'bi-cloud-minus-fill', tags: [] },
    { name: 'bi-cloud-minus', tags: [] },
    { name: 'bi-cloud-moon-fill', tags: [] },
    { name: 'bi-cloud-moon', tags: [] },
    { name: 'bi-cloud-plus-fill', tags: [] },
    { name: 'bi-cloud-plus', tags: [] },
    { name: 'bi-cloud-rain-fill', tags: [] },
    { name: 'bi-cloud-rain-heavy-fill', tags: [] },
    { name: 'bi-cloud-rain-heavy', tags: [] },
    { name: 'bi-cloud-rain', tags: [] },
    { name: 'bi-cloud-slash-fill', tags: [] },
    { name: 'bi-cloud-slash', tags: [] },
    { name: 'bi-cloud-sleet-fill', tags: [] },
    { name: 'bi-cloud-sleet', tags: [] },
    { name: 'bi-cloud-snow-fill', tags: [] },
    { name: 'bi-cloud-snow', tags: [] },
    { name: 'bi-cloud-sun-fill', tags: [] },
    { name: 'bi-cloud-sun', tags: [] },
    { name: 'bi-cloud-upload-fill', tags: [] },
    { name: 'bi-cloud-upload', tags: [] },
    { name: 'bi-cloud', tags: [] },
    { name: 'bi-clouds-fill', tags: [] },
    { name: 'bi-clouds', tags: [] },
    { name: 'bi-cloudy-fill', tags: [] },
    { name: 'bi-cloudy', tags: [] },
    { name: 'bi-code-slash', tags: [] },
    { name: 'bi-code-square', tags: [] },
    { name: 'bi-code', tags: [] },
    { name: 'bi-collection-fill', tags: [] },
    { name: 'bi-collection-play-fill', tags: [] },
    { name: 'bi-collection-play', tags: [] },
    { name: 'bi-collection', tags: [] },
    { name: 'bi-columns-gap', tags: [] },
    { name: 'bi-columns', tags: [] },
    { name: 'bi-command', tags: [] },
    { name: 'bi-compass-fill', tags: [] },
    { name: 'bi-compass', tags: [] },
    { name: 'bi-cone-striped', tags: [] },
    { name: 'bi-cone', tags: [] },
    { name: 'bi-controller', tags: [] },
    { name: 'bi-cpu-fill', tags: [] },
    { name: 'bi-cpu', tags: [] },
    { name: 'bi-credit-card-2-back-fill', tags: [] },
    { name: 'bi-credit-card-2-back', tags: [] },
    { name: 'bi-credit-card-2-front-fill', tags: [] },
    { name: 'bi-credit-card-2-front', tags: [] },
    { name: 'bi-credit-card-fill', tags: [] },
    { name: 'bi-credit-card', tags: [] },
    { name: 'bi-crop', tags: [] },
    { name: 'bi-cup-fill', tags: [] },
    { name: 'bi-cup-straw', tags: [] },
    { name: 'bi-cup', tags: [] },
    { name: 'bi-cursor-fill', tags: [] },
    { name: 'bi-cursor-text', tags: [] },
    { name: 'bi-cursor', tags: [] },
    { name: 'bi-dash-circle-dotted', tags: [] },
    { name: 'bi-dash-circle-fill', tags: [] },
    { name: 'bi-dash-circle', tags: [] },
    { name: 'bi-dash-square-dotted', tags: [] },
    { name: 'bi-dash-square-fill', tags: [] },
    { name: 'bi-dash-square', tags: [] },
    { name: 'bi-dash', tags: [] },
    { name: 'bi-diagram-2-fill', tags: [] },
    { name: 'bi-diagram-2', tags: [] },
    { name: 'bi-diagram-3-fill', tags: [] },
    { name: 'bi-diagram-3', tags: [] },
    { name: 'bi-diamond-fill', tags: [] },
    { name: 'bi-diamond-half', tags: [] },
    { name: 'bi-diamond', tags: [] },
    { name: 'bi-dice-1-fill', tags: [] },
    { name: 'bi-dice-1', tags: [] },
    { name: 'bi-dice-2-fill', tags: [] },
    { name: 'bi-dice-2', tags: [] },
    { name: 'bi-dice-3-fill', tags: [] },
    { name: 'bi-dice-3', tags: [] },
    { name: 'bi-dice-4-fill', tags: [] },
    { name: 'bi-dice-4', tags: [] },
    { name: 'bi-dice-5-fill', tags: [] },
    { name: 'bi-dice-5', tags: [] },
    { name: 'bi-dice-6-fill', tags: [] },
    { name: 'bi-dice-6', tags: [] },
    { name: 'bi-disc-fill', tags: [] },
    { name: 'bi-disc', tags: [] },
    { name: 'bi-discord', tags: [] },
    { name: 'bi-display-fill', tags: [] },
    { name: 'bi-display', tags: [] },
    { name: 'bi-distribute-horizontal', tags: [] },
    { name: 'bi-distribute-vertical', tags: [] },
    { name: 'bi-door-closed-fill', tags: [] },
    { name: 'bi-door-closed', tags: [] },
    { name: 'bi-door-open-fill', tags: [] },
    { name: 'bi-door-open', tags: [] },
    { name: 'bi-dot', tags: [] },
    { name: 'bi-download', tags: [] },
    { name: 'bi-droplet-fill', tags: [] },
    { name: 'bi-droplet-half', tags: [] },
    { name: 'bi-droplet', tags: [] },
    { name: 'bi-earbuds', tags: [] },
    { name: 'bi-easel-fill', tags: [] },
    { name: 'bi-easel', tags: [] },
    { name: 'bi-egg-fill', tags: [] },
    { name: 'bi-egg-fried', tags: [] },
    { name: 'bi-egg', tags: [] },
    { name: 'bi-eject-fill', tags: [] },
    { name: 'bi-eject', tags: [] },
    { name: 'bi-emoji-angry-fill', tags: [] },
    { name: 'bi-emoji-angry', tags: [] },
    { name: 'bi-emoji-dizzy-fill', tags: [] },
    { name: 'bi-emoji-dizzy', tags: [] },
    { name: 'bi-emoji-expressionless-fill', tags: [] },
    { name: 'bi-emoji-expressionless', tags: [] },
    { name: 'bi-emoji-frown-fill', tags: [] },
    { name: 'bi-emoji-frown', tags: [] },
    { name: 'bi-emoji-heart-eyes-fill', tags: [] },
    { name: 'bi-emoji-heart-eyes', tags: [] },
    { name: 'bi-emoji-laughing-fill', tags: [] },
    { name: 'bi-emoji-laughing', tags: [] },
    { name: 'bi-emoji-neutral-fill', tags: [] },
    { name: 'bi-emoji-neutral', tags: [] },
    { name: 'bi-emoji-smile-fill', tags: [] },
    { name: 'bi-emoji-smile-upside-down-fill', tags: [] },
    { name: 'bi-emoji-smile-upside-down', tags: [] },
    { name: 'bi-emoji-smile', tags: [] },
    { name: 'bi-emoji-sunglasses-fill', tags: [] },
    { name: 'bi-emoji-sunglasses', tags: [] },
    { name: 'bi-emoji-wink-fill', tags: [] },
    { name: 'bi-emoji-wink', tags: [] },
    { name: 'bi-envelope-fill', tags: [] },
    { name: 'bi-envelope-open-fill', tags: [] },
    { name: 'bi-envelope-open', tags: [] },
    { name: 'bi-envelope', tags: [] },
    { name: 'bi-eraser-fill', tags: [] },
    { name: 'bi-eraser', tags: [] },
    { name: 'bi-exclamation-circle-fill', tags: [] },
    { name: 'bi-exclamation-circle', tags: [] },
    { name: 'bi-exclamation-diamond-fill', tags: [] },
    { name: 'bi-exclamation-diamond', tags: [] },
    { name: 'bi-exclamation-octagon-fill', tags: [] },
    { name: 'bi-exclamation-octagon', tags: [] },
    { name: 'bi-exclamation-square-fill', tags: [] },
    { name: 'bi-exclamation-square', tags: [] },
    { name: 'bi-exclamation-triangle-fill', tags: [] },
    { name: 'bi-exclamation-triangle', tags: [] },
    { name: 'bi-exclamation', tags: [] },
    { name: 'bi-exclude', tags: [] },
    { name: 'bi-eye-fill', tags: [] },
    { name: 'bi-eye-slash-fill', tags: [] },
    { name: 'bi-eye-slash', tags: [] },
    { name: 'bi-eye', tags: [] },
    { name: 'bi-eyedropper', tags: [] },
    { name: 'bi-eyeglasses', tags: [] },
    { name: 'bi-facebook', tags: [] },
    { name: 'bi-file-arrow-down-fill', tags: [] },
    { name: 'bi-file-arrow-down', tags: [] },
    { name: 'bi-file-arrow-up-fill', tags: [] },
    { name: 'bi-file-arrow-up', tags: [] },
    { name: 'bi-file-bar-graph-fill', tags: [] },
    { name: 'bi-file-bar-graph', tags: [] },
    { name: 'bi-file-binary-fill', tags: [] },
    { name: 'bi-file-binary', tags: [] },
    { name: 'bi-file-break-fill', tags: [] },
    { name: 'bi-file-break', tags: [] },
    { name: 'bi-file-check-fill', tags: [] },
    { name: 'bi-file-check', tags: [] },
    { name: 'bi-file-code-fill', tags: [] },
    { name: 'bi-file-code', tags: [] },
    { name: 'bi-file-diff-fill', tags: [] },
    { name: 'bi-file-diff', tags: [] },
    { name: 'bi-file-earmark-arrow-down-fill', tags: [] },
    { name: 'bi-file-earmark-arrow-down', tags: [] },
    { name: 'bi-file-earmark-arrow-up-fill', tags: [] },
    { name: 'bi-file-earmark-arrow-up', tags: [] },
    { name: 'bi-file-earmark-bar-graph-fill', tags: [] },
    { name: 'bi-file-earmark-bar-graph', tags: [] },
    { name: 'bi-file-earmark-binary-fill', tags: [] },
    { name: 'bi-file-earmark-binary', tags: [] },
    { name: 'bi-file-earmark-break-fill', tags: [] },
    { name: 'bi-file-earmark-break', tags: [] },
    { name: 'bi-file-earmark-check-fill', tags: [] },
    { name: 'bi-file-earmark-check', tags: [] },
    { name: 'bi-file-earmark-code-fill', tags: [] },
    { name: 'bi-file-earmark-code', tags: [] },
    { name: 'bi-file-earmark-diff-fill', tags: [] },
    { name: 'bi-file-earmark-diff', tags: [] },
    { name: 'bi-file-earmark-easel-fill', tags: [] },
    { name: 'bi-file-earmark-easel', tags: [] },
    { name: 'bi-file-earmark-excel-fill', tags: [] },
    { name: 'bi-file-earmark-excel', tags: [] },
    { name: 'bi-file-earmark-fill', tags: [] },
    { name: 'bi-file-earmark-font-fill', tags: [] },
    { name: 'bi-file-earmark-font', tags: [] },
    { name: 'bi-file-earmark-image-fill', tags: [] },
    { name: 'bi-file-earmark-image', tags: [] },
    { name: 'bi-file-earmark-lock-fill', tags: [] },
    { name: 'bi-file-earmark-lock', tags: [] },
    { name: 'bi-file-earmark-lock2-fill', tags: [] },
    { name: 'bi-file-earmark-lock2', tags: [] },
    { name: 'bi-file-earmark-medical-fill', tags: [] },
    { name: 'bi-file-earmark-medical', tags: [] },
    { name: 'bi-file-earmark-minus-fill', tags: [] },
    { name: 'bi-file-earmark-minus', tags: [] },
    { name: 'bi-file-earmark-music-fill', tags: [] },
    { name: 'bi-file-earmark-music', tags: [] },
    { name: 'bi-file-earmark-person-fill', tags: [] },
    { name: 'bi-file-earmark-person', tags: [] },
    { name: 'bi-file-earmark-play-fill', tags: [] },
    { name: 'bi-file-earmark-play', tags: [] },
    { name: 'bi-file-earmark-plus-fill', tags: [] },
    { name: 'bi-file-earmark-plus', tags: [] },
    { name: 'bi-file-earmark-post-fill', tags: [] },
    { name: 'bi-file-earmark-post', tags: [] },
    { name: 'bi-file-earmark-ppt-fill', tags: [] },
    { name: 'bi-file-earmark-ppt', tags: [] },
    { name: 'bi-file-earmark-richtext-fill', tags: [] },
    { name: 'bi-file-earmark-richtext', tags: [] },
    { name: 'bi-file-earmark-ruled-fill', tags: [] },
    { name: 'bi-file-earmark-ruled', tags: [] },
    { name: 'bi-file-earmark-slides-fill', tags: [] },
    { name: 'bi-file-earmark-slides', tags: [] },
    { name: 'bi-file-earmark-spreadsheet-fill', tags: [] },
    { name: 'bi-file-earmark-spreadsheet', tags: [] },
    { name: 'bi-file-earmark-text-fill', tags: [] },
    { name: 'bi-file-earmark-text', tags: [] },
    { name: 'bi-file-earmark-word-fill', tags: [] },
    { name: 'bi-file-earmark-word', tags: [] },
    { name: 'bi-file-earmark-x-fill', tags: [] },
    { name: 'bi-file-earmark-x', tags: [] },
    { name: 'bi-file-earmark-zip-fill', tags: [] },
    { name: 'bi-file-earmark-zip', tags: [] },
    { name: 'bi-file-earmark', tags: [] },
    { name: 'bi-file-easel-fill', tags: [] },
    { name: 'bi-file-easel', tags: [] },
    { name: 'bi-file-excel-fill', tags: [] },
    { name: 'bi-file-excel', tags: [] },
    { name: 'bi-file-fill', tags: [] },
    { name: 'bi-file-font-fill', tags: [] },
    { name: 'bi-file-font', tags: [] },
    { name: 'bi-file-image-fill', tags: [] },
    { name: 'bi-file-image', tags: [] },
    { name: 'bi-file-lock-fill', tags: [] },
    { name: 'bi-file-lock', tags: [] },
    { name: 'bi-file-lock2-fill', tags: [] },
    { name: 'bi-file-lock2', tags: [] },
    { name: 'bi-file-medical-fill', tags: [] },
    { name: 'bi-file-medical', tags: [] },
    { name: 'bi-file-minus-fill', tags: [] },
    { name: 'bi-file-minus', tags: [] },
    { name: 'bi-file-music-fill', tags: [] },
    { name: 'bi-file-music', tags: [] },
    { name: 'bi-file-person-fill', tags: [] },
    { name: 'bi-file-person', tags: [] },
    { name: 'bi-file-play-fill', tags: [] },
    { name: 'bi-file-play', tags: [] },
    { name: 'bi-file-plus-fill', tags: [] },
    { name: 'bi-file-plus', tags: [] },
    { name: 'bi-file-post-fill', tags: [] },
    { name: 'bi-file-post', tags: [] },
    { name: 'bi-file-ppt-fill', tags: [] },
    { name: 'bi-file-ppt', tags: [] },
    { name: 'bi-file-richtext-fill', tags: [] },
    { name: 'bi-file-richtext', tags: [] },
    { name: 'bi-file-ruled-fill', tags: [] },
    { name: 'bi-file-ruled', tags: [] },
    { name: 'bi-file-slides-fill', tags: [] },
    { name: 'bi-file-slides', tags: [] },
    { name: 'bi-file-spreadsheet-fill', tags: [] },
    { name: 'bi-file-spreadsheet', tags: [] },
    { name: 'bi-file-text-fill', tags: [] },
    { name: 'bi-file-text', tags: [] },
    { name: 'bi-file-word-fill', tags: [] },
    { name: 'bi-file-word', tags: [] },
    { name: 'bi-file-x-fill', tags: [] },
    { name: 'bi-file-x', tags: [] },
    { name: 'bi-file-zip-fill', tags: [] },
    { name: 'bi-file-zip', tags: [] },
    { name: 'bi-file', tags: [] },
    { name: 'bi-files-alt', tags: [] },
    { name: 'bi-files', tags: [] },
    { name: 'bi-film', tags: [] },
    { name: 'bi-filter-circle-fill', tags: [] },
    { name: 'bi-filter-circle', tags: [] },
    { name: 'bi-filter-left', tags: [] },
    { name: 'bi-filter-right', tags: [] },
    { name: 'bi-filter-square-fill', tags: [] },
    { name: 'bi-filter-square', tags: [] },
    { name: 'bi-filter', tags: [] },
    { name: 'bi-flag-fill', tags: [] },
    { name: 'bi-flag', tags: [] },
    { name: 'bi-flower1', tags: [] },
    { name: 'bi-flower2', tags: [] },
    { name: 'bi-flower3', tags: [] },
    { name: 'bi-folder-check', tags: [] },
    { name: 'bi-folder-fill', tags: [] },
    { name: 'bi-folder-minus', tags: [] },
    { name: 'bi-folder-plus', tags: [] },
    { name: 'bi-folder-symlink-fill', tags: [] },
    { name: 'bi-folder-symlink', tags: [] },
    { name: 'bi-folder-x', tags: [] },
    { name: 'bi-folder', tags: [] },
    { name: 'bi-folder2-open', tags: [] },
    { name: 'bi-folder2', tags: [] },
    { name: 'bi-fonts', tags: [] },
    { name: 'bi-forward-fill', tags: [] },
    { name: 'bi-forward', tags: [] },
    { name: 'bi-front', tags: [] },
    { name: 'bi-fullscreen-exit', tags: [] },
    { name: 'bi-fullscreen', tags: [] },
    { name: 'bi-funnel-fill', tags: [] },
    { name: 'bi-funnel', tags: [] },
    { name: 'bi-gear-fill', tags: [] },
    { name: 'bi-gear-wide-connected', tags: [] },
    { name: 'bi-gear-wide', tags: [] },
    { name: 'bi-gear', tags: [] },
    { name: 'bi-gem', tags: [] },
    { name: 'bi-geo-alt-fill', tags: [] },
    { name: 'bi-geo-alt', tags: [] },
    { name: 'bi-geo-fill', tags: [] },
    { name: 'bi-geo', tags: [] },
    { name: 'bi-gift-fill', tags: [] },
    { name: 'bi-gift', tags: [] },
    { name: 'bi-github', tags: [] },
    { name: 'bi-globe', tags: [] },
    { name: 'bi-globe2', tags: [] },
    { name: 'bi-google', tags: [] },
    { name: 'bi-graph-down', tags: [] },
    { name: 'bi-graph-up', tags: [] },
    { name: 'bi-grid-1x2-fill', tags: [] },
    { name: 'bi-grid-1x2', tags: [] },
    { name: 'bi-grid-3x2-gap-fill', tags: [] },
    { name: 'bi-grid-3x2-gap', tags: [] },
    { name: 'bi-grid-3x2', tags: [] },
    { name: 'bi-grid-3x3-gap-fill', tags: [] },
    { name: 'bi-grid-3x3-gap', tags: [] },
    { name: 'bi-grid-3x3', tags: [] },
    { name: 'bi-grid-fill', tags: [] },
    { name: 'bi-grid', tags: [] },
    { name: 'bi-grip-horizontal', tags: [] },
    { name: 'bi-grip-vertical', tags: [] },
    { name: 'bi-hammer', tags: [] },
    { name: 'bi-hand-index-fill', tags: [] },
    { name: 'bi-hand-index-thumb-fill', tags: [] },
    { name: 'bi-hand-index-thumb', tags: [] },
    { name: 'bi-hand-index', tags: [] },
    { name: 'bi-hand-thumbs-down-fill', tags: [] },
    { name: 'bi-hand-thumbs-down', tags: [] },
    { name: 'bi-hand-thumbs-up-fill', tags: [] },
    { name: 'bi-hand-thumbs-up', tags: [] },
    { name: 'bi-handbag-fill', tags: [] },
    { name: 'bi-handbag', tags: [] },
    { name: 'bi-hash', tags: [] },
    { name: 'bi-hdd-fill', tags: [] },
    { name: 'bi-hdd-network-fill', tags: [] },
    { name: 'bi-hdd-network', tags: [] },
    { name: 'bi-hdd-rack-fill', tags: [] },
    { name: 'bi-hdd-rack', tags: [] },
    { name: 'bi-hdd-stack-fill', tags: [] },
    { name: 'bi-hdd-stack', tags: [] },
    { name: 'bi-hdd', tags: [] },
    { name: 'bi-headphones', tags: [] },
    { name: 'bi-headset', tags: [] },
    { name: 'bi-heart-fill', tags: [] },
    { name: 'bi-heart-half', tags: [] },
    { name: 'bi-heart', tags: [] },
    { name: 'bi-heptagon-fill', tags: [] },
    { name: 'bi-heptagon-half', tags: [] },
    { name: 'bi-heptagon', tags: [] },
    { name: 'bi-hexagon-fill', tags: [] },
    { name: 'bi-hexagon-half', tags: [] },
    { name: 'bi-hexagon', tags: [] },
    { name: 'bi-hourglass-bottom', tags: [] },
    { name: 'bi-hourglass-split', tags: [] },
    { name: 'bi-hourglass-top', tags: [] },
    { name: 'bi-hourglass', tags: [] },
    { name: 'bi-house-door-fill', tags: [] },
    { name: 'bi-house-door', tags: [] },
    { name: 'bi-house-fill', tags: [] },
    { name: 'bi-house', tags: [] },
    { name: 'bi-hr', tags: [] },
    { name: 'bi-hurricane', tags: [] },
    { name: 'bi-image-alt', tags: [] },
    { name: 'bi-image-fill', tags: [] },
    { name: 'bi-image', tags: [] },
    { name: 'bi-images', tags: [] },
    { name: 'bi-inbox-fill', tags: [] },
    { name: 'bi-inbox', tags: [] },
    { name: 'bi-inboxes-fill', tags: [] },
    { name: 'bi-inboxes', tags: [] },
    { name: 'bi-info-circle-fill', tags: [] },
    { name: 'bi-info-circle', tags: [] },
    { name: 'bi-info-square-fill', tags: [] },
    { name: 'bi-info-square', tags: [] },
    { name: 'bi-info', tags: [] },
    { name: 'bi-input-cursor-text', tags: [] },
    { name: 'bi-input-cursor', tags: [] },
    { name: 'bi-instagram', tags: [] },
    { name: 'bi-intersect', tags: [] },
    { name: 'bi-journal-album', tags: [] },
    { name: 'bi-journal-arrow-down', tags: [] },
    { name: 'bi-journal-arrow-up', tags: [] },
    { name: 'bi-journal-bookmark-fill', tags: [] },
    { name: 'bi-journal-bookmark', tags: [] },
    { name: 'bi-journal-check', tags: [] },
    { name: 'bi-journal-code', tags: [] },
    { name: 'bi-journal-medical', tags: [] },
    { name: 'bi-journal-minus', tags: [] },
    { name: 'bi-journal-plus', tags: [] },
    { name: 'bi-journal-richtext', tags: [] },
    { name: 'bi-journal-text', tags: [] },
    { name: 'bi-journal-x', tags: [] },
    { name: 'bi-journal', tags: [] },
    { name: 'bi-journals', tags: [] },
    { name: 'bi-joystick', tags: [] },
    { name: 'bi-justify-left', tags: [] },
    { name: 'bi-justify-right', tags: [] },
    { name: 'bi-justify', tags: [] },
    { name: 'bi-kanban-fill', tags: [] },
    { name: 'bi-kanban', tags: [] },
    { name: 'bi-key-fill', tags: [] },
    { name: 'bi-key', tags: [] },
    { name: 'bi-keyboard-fill', tags: [] },
    { name: 'bi-keyboard', tags: [] },
    { name: 'bi-ladder', tags: [] },
    { name: 'bi-lamp-fill', tags: [] },
    { name: 'bi-lamp', tags: [] },
    { name: 'bi-laptop-fill', tags: [] },
    { name: 'bi-laptop', tags: [] },
    { name: 'bi-layer-backward', tags: [] },
    { name: 'bi-layer-forward', tags: [] },
    { name: 'bi-layers-fill', tags: [] },
    { name: 'bi-layers-half', tags: [] },
    { name: 'bi-layers', tags: [] },
    { name: 'bi-layout-sidebar-inset-reverse', tags: [] },
    { name: 'bi-layout-sidebar-inset', tags: [] },
    { name: 'bi-layout-sidebar-reverse', tags: [] },
    { name: 'bi-layout-sidebar', tags: [] },
    { name: 'bi-layout-split', tags: [] },
    { name: 'bi-layout-text-sidebar-reverse', tags: [] },
    { name: 'bi-layout-text-sidebar', tags: [] },
    { name: 'bi-layout-text-window-reverse', tags: [] },
    { name: 'bi-layout-text-window', tags: [] },
    { name: 'bi-layout-three-columns', tags: [] },
    { name: 'bi-layout-wtf', tags: [] },
    { name: 'bi-life-preserver', tags: [] },
    { name: 'bi-lightbulb-fill', tags: [] },
    { name: 'bi-lightbulb-off-fill', tags: [] },
    { name: 'bi-lightbulb-off', tags: [] },
    { name: 'bi-lightbulb', tags: [] },
    { name: 'bi-lightning-charge-fill', tags: [] },
    { name: 'bi-lightning-charge', tags: [] },
    { name: 'bi-lightning-fill', tags: [] },
    { name: 'bi-lightning', tags: [] },
    { name: 'bi-link-45deg', tags: [] },
    { name: 'bi-link', tags: [] },
    { name: 'bi-linkedin', tags: [] },
    { name: 'bi-list-check', tags: [] },
    { name: 'bi-list-nested', tags: [] },
    { name: 'bi-list-ol', tags: [] },
    { name: 'bi-list-stars', tags: [] },
    { name: 'bi-list-task', tags: [] },
    { name: 'bi-list-ul', tags: [] },
    { name: 'bi-list', tags: [] },
    { name: 'bi-lock-fill', tags: [] },
    { name: 'bi-lock', tags: [] },
    { name: 'bi-mailbox', tags: [] },
    { name: 'bi-mailbox2', tags: [] },
    { name: 'bi-map-fill', tags: [] },
    { name: 'bi-map', tags: [] },
    { name: 'bi-markdown-fill', tags: [] },
    { name: 'bi-markdown', tags: [] },
    { name: 'bi-mask', tags: [] },
    { name: 'bi-megaphone-fill', tags: [] },
    { name: 'bi-megaphone', tags: [] },
    { name: 'bi-menu-app-fill', tags: [] },
    { name: 'bi-menu-app', tags: [] },
    { name: 'bi-menu-button-fill', tags: [] },
    { name: 'bi-menu-button-wide-fill', tags: [] },
    { name: 'bi-menu-button-wide', tags: [] },
    { name: 'bi-menu-button', tags: [] },
    { name: 'bi-menu-down', tags: [] },
    { name: 'bi-menu-up', tags: [] },
    { name: 'bi-mic-fill', tags: [] },
    { name: 'bi-mic-mute-fill', tags: [] },
    { name: 'bi-mic-mute', tags: [] },
    { name: 'bi-mic', tags: [] },
    { name: 'bi-minecart-loaded', tags: [] },
    { name: 'bi-minecart', tags: [] },
    { name: 'bi-moisture', tags: [] },
    { name: 'bi-moon-fill', tags: [] },
    { name: 'bi-moon-stars-fill', tags: [] },
    { name: 'bi-moon-stars', tags: [] },
    { name: 'bi-moon', tags: [] },
    { name: 'bi-mouse-fill', tags: [] },
    { name: 'bi-mouse', tags: [] },
    { name: 'bi-mouse2-fill', tags: [] },
    { name: 'bi-mouse2', tags: [] },
    { name: 'bi-mouse3-fill', tags: [] },
    { name: 'bi-mouse3', tags: [] },
    { name: 'bi-music-note-beamed', tags: [] },
    { name: 'bi-music-note-list', tags: [] },
    { name: 'bi-music-note', tags: [] },
    { name: 'bi-music-player-fill', tags: [] },
    { name: 'bi-music-player', tags: [] },
    { name: 'bi-newspaper', tags: [] },
    { name: 'bi-node-minus-fill', tags: [] },
    { name: 'bi-node-minus', tags: [] },
    { name: 'bi-node-plus-fill', tags: [] },
    { name: 'bi-node-plus', tags: [] },
    { name: 'bi-nut-fill', tags: [] },
    { name: 'bi-nut', tags: [] },
    { name: 'bi-octagon-fill', tags: [] },
    { name: 'bi-octagon-half', tags: [] },
    { name: 'bi-octagon', tags: [] },
    { name: 'bi-option', tags: [] },
    { name: 'bi-outlet', tags: [] },
    { name: 'bi-paint-bucket', tags: [] },
    { name: 'bi-palette-fill', tags: [] },
    { name: 'bi-palette', tags: [] },
    { name: 'bi-palette2', tags: [] },
    { name: 'bi-paperclip', tags: [] },
    { name: 'bi-paragraph', tags: [] },
    { name: 'bi-patch-check-fill', tags: [] },
    { name: 'bi-patch-check', tags: [] },
    { name: 'bi-patch-exclamation-fill', tags: [] },
    { name: 'bi-patch-exclamation', tags: [] },
    { name: 'bi-patch-minus-fill', tags: [] },
    { name: 'bi-patch-minus', tags: [] },
    { name: 'bi-patch-plus-fill', tags: [] },
    { name: 'bi-patch-plus', tags: [] },
    { name: 'bi-patch-question-fill', tags: [] },
    { name: 'bi-patch-question', tags: [] },
    { name: 'bi-pause-btn-fill', tags: [] },
    { name: 'bi-pause-btn', tags: [] },
    { name: 'bi-pause-circle-fill', tags: [] },
    { name: 'bi-pause-circle', tags: [] },
    { name: 'bi-pause-fill', tags: [] },
    { name: 'bi-pause', tags: [] },
    { name: 'bi-peace-fill', tags: [] },
    { name: 'bi-peace', tags: [] },
    { name: 'bi-pen-fill', tags: [] },
    { name: 'bi-pen', tags: [] },
    { name: 'bi-pencil-fill', tags: [] },
    { name: 'bi-pencil-square', tags: [] },
    { name: 'bi-pencil', tags: [] },
    { name: 'bi-pentagon-fill', tags: [] },
    { name: 'bi-pentagon-half', tags: [] },
    { name: 'bi-pentagon', tags: [] },
    { name: 'bi-people-fill', tags: [] },
    { name: 'bi-people', tags: [] },
    { name: 'bi-percent', tags: [] },
    { name: 'bi-person-badge-fill', tags: [] },
    { name: 'bi-person-badge', tags: [] },
    { name: 'bi-person-bounding-box', tags: [] },
    { name: 'bi-person-check-fill', tags: [] },
    { name: 'bi-person-check', tags: [] },
    { name: 'bi-person-circle', tags: [] },
    { name: 'bi-person-dash-fill', tags: [] },
    { name: 'bi-person-dash', tags: [] },
    { name: 'bi-person-fill', tags: [] },
    { name: 'bi-person-lines-fill', tags: [] },
    { name: 'bi-person-plus-fill', tags: [] },
    { name: 'bi-person-plus', tags: [] },
    { name: 'bi-person-square', tags: [] },
    { name: 'bi-person-x-fill', tags: [] },
    { name: 'bi-person-x', tags: [] },
    { name: 'bi-person', tags: [] },
    { name: 'bi-phone-fill', tags: [] },
    { name: 'bi-phone-landscape-fill', tags: [] },
    { name: 'bi-phone-landscape', tags: [] },
    { name: 'bi-phone-vibrate-fill', tags: [] },
    { name: 'bi-phone-vibrate', tags: [] },
    { name: 'bi-phone', tags: [] },
    { name: 'bi-pie-chart-fill', tags: [] },
    { name: 'bi-pie-chart', tags: [] },
    { name: 'bi-pin-angle-fill', tags: [] },
    { name: 'bi-pin-angle', tags: [] },
    { name: 'bi-pin-fill', tags: [] },
    { name: 'bi-pin', tags: [] },
    { name: 'bi-pip-fill', tags: [] },
    { name: 'bi-pip', tags: [] },
    { name: 'bi-play-btn-fill', tags: [] },
    { name: 'bi-play-btn', tags: [] },
    { name: 'bi-play-circle-fill', tags: [] },
    { name: 'bi-play-circle', tags: [] },
    { name: 'bi-play-fill', tags: [] },
    { name: 'bi-play', tags: [] },
    { name: 'bi-plug-fill', tags: [] },
    { name: 'bi-plug', tags: [] },
    { name: 'bi-plus-circle-dotted', tags: [] },
    { name: 'bi-plus-circle-fill', tags: [] },
    { name: 'bi-plus-circle', tags: [] },
    { name: 'bi-plus-square-dotted', tags: [] },
    { name: 'bi-plus-square-fill', tags: [] },
    { name: 'bi-plus-square', tags: [] },
    { name: 'bi-plus', tags: [] },
    { name: 'bi-power', tags: [] },
    { name: 'bi-printer-fill', tags: [] },
    { name: 'bi-printer', tags: [] },
    { name: 'bi-puzzle-fill', tags: [] },
    { name: 'bi-puzzle', tags: [] },
    { name: 'bi-question-circle-fill', tags: [] },
    { name: 'bi-question-circle', tags: [] },
    { name: 'bi-question-diamond-fill', tags: [] },
    { name: 'bi-question-diamond', tags: [] },
    { name: 'bi-question-octagon-fill', tags: [] },
    { name: 'bi-question-octagon', tags: [] },
    { name: 'bi-question-square-fill', tags: [] },
    { name: 'bi-question-square', tags: [] },
    { name: 'bi-question', tags: [] },
    { name: 'bi-rainbow', tags: [] },
    { name: 'bi-receipt-cutoff', tags: [] },
    { name: 'bi-receipt', tags: [] },
    { name: 'bi-reception-0', tags: [] },
    { name: 'bi-reception-1', tags: [] },
    { name: 'bi-reception-2', tags: [] },
    { name: 'bi-reception-3', tags: [] },
    { name: 'bi-reception-4', tags: [] },
    { name: 'bi-record-btn-fill', tags: [] },
    { name: 'bi-record-btn', tags: [] },
    { name: 'bi-record-circle-fill', tags: [] },
    { name: 'bi-record-circle', tags: [] },
    { name: 'bi-record-fill', tags: [] },
    { name: 'bi-record', tags: [] },
    { name: 'bi-record2-fill', tags: [] },
    { name: 'bi-record2', tags: [] },
    { name: 'bi-reply-all-fill', tags: [] },
    { name: 'bi-reply-all', tags: [] },
    { name: 'bi-reply-fill', tags: [] },
    { name: 'bi-reply', tags: [] },
    { name: 'bi-rss-fill', tags: [] },
    { name: 'bi-rss', tags: [] },
    { name: 'bi-rulers', tags: [] },
    { name: 'bi-save-fill', tags: [] },
    { name: 'bi-save', tags: [] },
    { name: 'bi-save2-fill', tags: [] },
    { name: 'bi-save2', tags: [] },
    { name: 'bi-scissors', tags: [] },
    { name: 'bi-screwdriver', tags: [] },
    { name: 'bi-search', tags: [] },
    { name: 'bi-segmented-nav', tags: [] },
    { name: 'bi-server', tags: [] },
    { name: 'bi-share-fill', tags: [] },
    { name: 'bi-share', tags: [] },
    { name: 'bi-shield-check', tags: [] },
    { name: 'bi-shield-exclamation', tags: [] },
    { name: 'bi-shield-fill-check', tags: [] },
    { name: 'bi-shield-fill-exclamation', tags: [] },
    { name: 'bi-shield-fill-minus', tags: [] },
    { name: 'bi-shield-fill-plus', tags: [] },
    { name: 'bi-shield-fill-x', tags: [] },
    { name: 'bi-shield-fill', tags: [] },
    { name: 'bi-shield-lock-fill', tags: [] },
    { name: 'bi-shield-lock', tags: [] },
    { name: 'bi-shield-minus', tags: [] },
    { name: 'bi-shield-plus', tags: [] },
    { name: 'bi-shield-shaded', tags: [] },
    { name: 'bi-shield-slash-fill', tags: [] },
    { name: 'bi-shield-slash', tags: [] },
    { name: 'bi-shield-x', tags: [] },
    { name: 'bi-shield', tags: [] },
    { name: 'bi-shift-fill', tags: [] },
    { name: 'bi-shift', tags: [] },
    { name: 'bi-shop-window', tags: [] },
    { name: 'bi-shop', tags: [] },
    { name: 'bi-shuffle', tags: [] },
    { name: 'bi-signpost-2-fill', tags: [] },
    { name: 'bi-signpost-2', tags: [] },
    { name: 'bi-signpost-fill', tags: [] },
    { name: 'bi-signpost-split-fill', tags: [] },
    { name: 'bi-signpost-split', tags: [] },
    { name: 'bi-signpost', tags: [] },
    { name: 'bi-sim-fill', tags: [] },
    { name: 'bi-sim', tags: [] },
    { name: 'bi-skip-backward-btn-fill', tags: [] },
    { name: 'bi-skip-backward-btn', tags: [] },
    { name: 'bi-skip-backward-circle-fill', tags: [] },
    { name: 'bi-skip-backward-circle', tags: [] },
    { name: 'bi-skip-backward-fill', tags: [] },
    { name: 'bi-skip-backward', tags: [] },
    { name: 'bi-skip-end-btn-fill', tags: [] },
    { name: 'bi-skip-end-btn', tags: [] },
    { name: 'bi-skip-end-circle-fill', tags: [] },
    { name: 'bi-skip-end-circle', tags: [] },
    { name: 'bi-skip-end-fill', tags: [] },
    { name: 'bi-skip-end', tags: [] },
    { name: 'bi-skip-forward-btn-fill', tags: [] },
    { name: 'bi-skip-forward-btn', tags: [] },
    { name: 'bi-skip-forward-circle-fill', tags: [] },
    { name: 'bi-skip-forward-circle', tags: [] },
    { name: 'bi-skip-forward-fill', tags: [] },
    { name: 'bi-skip-forward', tags: [] },
    { name: 'bi-skip-start-btn-fill', tags: [] },
    { name: 'bi-skip-start-btn', tags: [] },
    { name: 'bi-skip-start-circle-fill', tags: [] },
    { name: 'bi-skip-start-circle', tags: [] },
    { name: 'bi-skip-start-fill', tags: [] },
    { name: 'bi-skip-start', tags: [] },
    { name: 'bi-slack', tags: [] },
    { name: 'bi-slash-circle-fill', tags: [] },
    { name: 'bi-slash-circle', tags: [] },
    { name: 'bi-slash-square-fill', tags: [] },
    { name: 'bi-slash-square', tags: [] },
    { name: 'bi-slash', tags: [] },
    { name: 'bi-sliders', tags: [] },
    { name: 'bi-smartwatch', tags: [] },
    { name: 'bi-snow', tags: [] },
    { name: 'bi-snow2', tags: [] },
    { name: 'bi-snow3', tags: [] },
    { name: 'bi-sort-alpha-down-alt', tags: [] },
    { name: 'bi-sort-alpha-down', tags: [] },
    { name: 'bi-sort-alpha-up-alt', tags: [] },
    { name: 'bi-sort-alpha-up', tags: [] },
    { name: 'bi-sort-down-alt', tags: [] },
    { name: 'bi-sort-down', tags: [] },
    { name: 'bi-sort-numeric-down-alt', tags: [] },
    { name: 'bi-sort-numeric-down', tags: [] },
    { name: 'bi-sort-numeric-up-alt', tags: [] },
    { name: 'bi-sort-numeric-up', tags: [] },
    { name: 'bi-sort-up-alt', tags: [] },
    { name: 'bi-sort-up', tags: [] },
    { name: 'bi-soundwave', tags: [] },
    { name: 'bi-speaker-fill', tags: [] },
    { name: 'bi-speaker', tags: [] },
    { name: 'bi-speedometer', tags: [] },
    { name: 'bi-speedometer2', tags: [] },
    { name: 'bi-spellcheck', tags: [] },
    { name: 'bi-square-fill', tags: [] },
    { name: 'bi-square-half', tags: [] },
    { name: 'bi-square', tags: [] },
    { name: 'bi-stack', tags: [] },
    { name: 'bi-star-fill', tags: [] },
    { name: 'bi-star-half', tags: [] },
    { name: 'bi-star', tags: [] },
    { name: 'bi-stars', tags: [] },
    { name: 'bi-stickies-fill', tags: [] },
    { name: 'bi-stickies', tags: [] },
    { name: 'bi-sticky-fill', tags: [] },
    { name: 'bi-sticky', tags: [] },
    { name: 'bi-stop-btn-fill', tags: [] },
    { name: 'bi-stop-btn', tags: [] },
    { name: 'bi-stop-circle-fill', tags: [] },
    { name: 'bi-stop-circle', tags: [] },
    { name: 'bi-stop-fill', tags: [] },
    { name: 'bi-stop', tags: [] },
    { name: 'bi-stoplights-fill', tags: [] },
    { name: 'bi-stoplights', tags: [] },
    { name: 'bi-stopwatch-fill', tags: [] },
    { name: 'bi-stopwatch', tags: [] },
    { name: 'bi-subtract', tags: [] },
    { name: 'bi-suit-club-fill', tags: [] },
    { name: 'bi-suit-club', tags: [] },
    { name: 'bi-suit-diamond-fill', tags: [] },
    { name: 'bi-suit-diamond', tags: [] },
    { name: 'bi-suit-heart-fill', tags: [] },
    { name: 'bi-suit-heart', tags: [] },
    { name: 'bi-suit-spade-fill', tags: [] },
    { name: 'bi-suit-spade', tags: [] },
    { name: 'bi-sun-fill', tags: [] },
    { name: 'bi-sun', tags: [] },
    { name: 'bi-sunglasses', tags: [] },
    { name: 'bi-sunrise-fill', tags: [] },
    { name: 'bi-sunrise', tags: [] },
    { name: 'bi-sunset-fill', tags: [] },
    { name: 'bi-sunset', tags: [] },
    { name: 'bi-symmetry-horizontal', tags: [] },
    { name: 'bi-symmetry-vertical', tags: [] },
    { name: 'bi-table', tags: [] },
    { name: 'bi-tablet-fill', tags: [] },
    { name: 'bi-tablet-landscape-fill', tags: [] },
    { name: 'bi-tablet-landscape', tags: [] },
    { name: 'bi-tablet', tags: [] },
    { name: 'bi-tag-fill', tags: [] },
    { name: 'bi-tag', tags: [] },
    { name: 'bi-tags-fill', tags: [] },
    { name: 'bi-tags', tags: [] },
    { name: 'bi-telegram', tags: [] },
    { name: 'bi-telephone-fill', tags: [] },
    { name: 'bi-telephone-forward-fill', tags: [] },
    { name: 'bi-telephone-forward', tags: [] },
    { name: 'bi-telephone-inbound-fill', tags: [] },
    { name: 'bi-telephone-inbound', tags: [] },
    { name: 'bi-telephone-minus-fill', tags: [] },
    { name: 'bi-telephone-minus', tags: [] },
    { name: 'bi-telephone-outbound-fill', tags: [] },
    { name: 'bi-telephone-outbound', tags: [] },
    { name: 'bi-telephone-plus-fill', tags: [] },
    { name: 'bi-telephone-plus', tags: [] },
    { name: 'bi-telephone-x-fill', tags: [] },
    { name: 'bi-telephone-x', tags: [] },
    { name: 'bi-telephone', tags: [] },
    { name: 'bi-terminal-fill', tags: [] },
    { name: 'bi-terminal', tags: [] },
    { name: 'bi-text-center', tags: [] },
    { name: 'bi-text-indent-left', tags: [] },
    { name: 'bi-text-indent-right', tags: [] },
    { name: 'bi-text-left', tags: [] },
    { name: 'bi-text-paragraph', tags: [] },
    { name: 'bi-text-right', tags: [] },
    { name: 'bi-textarea-resize', tags: [] },
    { name: 'bi-textarea-t', tags: [] },
    { name: 'bi-textarea', tags: [] },
    { name: 'bi-thermometer-half', tags: [] },
    { name: 'bi-thermometer-high', tags: [] },
    { name: 'bi-thermometer-low', tags: [] },
    { name: 'bi-thermometer-snow', tags: [] },
    { name: 'bi-thermometer-sun', tags: [] },
    { name: 'bi-thermometer', tags: [] },
    { name: 'bi-three-dots-vertical', tags: [] },
    { name: 'bi-three-dots', tags: [] },
    { name: 'bi-toggle-off', tags: [] },
    { name: 'bi-toggle-on', tags: [] },
    { name: 'bi-toggle2-off', tags: [] },
    { name: 'bi-toggle2-on', tags: [] },
    { name: 'bi-toggles', tags: [] },
    { name: 'bi-toggles2', tags: [] },
    { name: 'bi-tools', tags: [] },
    { name: 'bi-tornado', tags: [] },
    { name: 'bi-trash-fill', tags: [] },
    { name: 'bi-trash', tags: [] },
    { name: 'bi-trash2-fill', tags: [] },
    { name: 'bi-trash2', tags: [] },
    { name: 'bi-tree-fill', tags: [] },
    { name: 'bi-tree', tags: [] },
    { name: 'bi-triangle-fill', tags: [] },
    { name: 'bi-triangle-half', tags: [] },
    { name: 'bi-triangle', tags: [] },
    { name: 'bi-trophy-fill', tags: [] },
    { name: 'bi-trophy', tags: [] },
    { name: 'bi-tropical-storm', tags: [] },
    { name: 'bi-truck-flatbed', tags: [] },
    { name: 'bi-truck', tags: [] },
    { name: 'bi-tsunami', tags: [] },
    { name: 'bi-tv-fill', tags: [] },
    { name: 'bi-tv', tags: [] },
    { name: 'bi-twitch', tags: [] },
    { name: 'bi-twitter', tags: [] },
    { name: 'bi-type-bold', tags: [] },
    { name: 'bi-type-h1', tags: [] },
    { name: 'bi-type-h2', tags: [] },
    { name: 'bi-type-h3', tags: [] },
    { name: 'bi-type-italic', tags: [] },
    { name: 'bi-type-strikethrough', tags: [] },
    { name: 'bi-type-underline', tags: [] },
    { name: 'bi-type', tags: [] },
    { name: 'bi-ui-checks-grid', tags: [] },
    { name: 'bi-ui-checks', tags: [] },
    { name: 'bi-ui-radios-grid', tags: [] },
    { name: 'bi-ui-radios', tags: [] },
    { name: 'bi-umbrella-fill', tags: [] },
    { name: 'bi-umbrella', tags: [] },
    { name: 'bi-union', tags: [] },
    { name: 'bi-unlock-fill', tags: [] },
    { name: 'bi-unlock', tags: [] },
    { name: 'bi-upc-scan', tags: [] },
    { name: 'bi-upc', tags: [] },
    { name: 'bi-upload', tags: [] },
    { name: 'bi-vector-pen', tags: [] },
    { name: 'bi-view-list', tags: [] },
    { name: 'bi-view-stacked', tags: [] },
    { name: 'bi-vinyl-fill', tags: [] },
    { name: 'bi-vinyl', tags: [] },
    { name: 'bi-voicemail', tags: [] },
    { name: 'bi-volume-down-fill', tags: [] },
    { name: 'bi-volume-down', tags: [] },
    { name: 'bi-volume-mute-fill', tags: [] },
    { name: 'bi-volume-mute', tags: [] },
    { name: 'bi-volume-off-fill', tags: [] },
    { name: 'bi-volume-off', tags: [] },
    { name: 'bi-volume-up-fill', tags: [] },
    { name: 'bi-volume-up', tags: [] },
    { name: 'bi-vr', tags: [] },
    { name: 'bi-wallet-fill', tags: [] },
    { name: 'bi-wallet', tags: [] },
    { name: 'bi-wallet2', tags: [] },
    { name: 'bi-watch', tags: [] },
    { name: 'bi-water', tags: [] },
    { name: 'bi-whatsapp', tags: [] },
    { name: 'bi-wifi-1', tags: [] },
    { name: 'bi-wifi-2', tags: [] },
    { name: 'bi-wifi-off', tags: [] },
    { name: 'bi-wifi', tags: [] },
    { name: 'bi-wind', tags: [] },
    { name: 'bi-window-dock', tags: [] },
    { name: 'bi-window-sidebar', tags: [] },
    { name: 'bi-window', tags: [] },
    { name: 'bi-wrench', tags: [] },
    { name: 'bi-x-circle-fill', tags: [] },
    { name: 'bi-x-circle', tags: [] },
    { name: 'bi-x-diamond-fill', tags: [] },
    { name: 'bi-x-diamond', tags: [] },
    { name: 'bi-x-octagon-fill', tags: [] },
    { name: 'bi-x-octagon', tags: [] },
    { name: 'bi-x-square-fill', tags: [] },
    { name: 'bi-x-square', tags: [] },
    { name: 'bi-x', tags: [] },
    { name: 'bi-youtube', tags: [] },
    { name: 'bi-zoom-in', tags: [] },
    { name: 'bi-zoom-out', tags: [] },
    { name: 'bi-bank', tags: [] },
    { name: 'bi-bank2', tags: [] },
    { name: 'bi-bell-slash-fill', tags: [] },
    { name: 'bi-bell-slash', tags: [] },
    { name: 'bi-cash-coin', tags: [] },
    { name: 'bi-check-lg', tags: [] },
    { name: 'bi-coin', tags: [] },
    { name: 'bi-currency-bitcoin', tags: [] },
    { name: 'bi-currency-dollar', tags: [] },
    { name: 'bi-currency-euro', tags: [] },
    { name: 'bi-currency-exchange', tags: [] },
    { name: 'bi-currency-pound', tags: [] },
    { name: 'bi-currency-yen', tags: [] },
    { name: 'bi-dash-lg', tags: [] },
    { name: 'bi-exclamation-lg', tags: [] },
    { name: 'bi-file-earmark-pdf-fill', tags: [] },
    { name: 'bi-file-earmark-pdf', tags: [] },
    { name: 'bi-file-pdf-fill', tags: [] },
    { name: 'bi-file-pdf', tags: [] },
    { name: 'bi-gender-ambiguous', tags: [] },
    { name: 'bi-gender-female', tags: [] },
    { name: 'bi-gender-male', tags: [] },
    { name: 'bi-gender-trans', tags: [] },
    { name: 'bi-headset-vr', tags: [] },
    { name: 'bi-info-lg', tags: [] },
    { name: 'bi-mastodon', tags: [] },
    { name: 'bi-messenger', tags: [] },
    { name: 'bi-piggy-bank-fill', tags: [] },
    { name: 'bi-piggy-bank', tags: [] },
    { name: 'bi-pin-map-fill', tags: [] },
    { name: 'bi-pin-map', tags: [] },
    { name: 'bi-plus-lg', tags: [] },
    { name: 'bi-question-lg', tags: [] },
    { name: 'bi-recycle', tags: [] },
    { name: 'bi-reddit', tags: [] },
    { name: 'bi-safe-fill', tags: [] },
    { name: 'bi-safe2-fill', tags: [] },
    { name: 'bi-safe2', tags: [] },
    { name: 'bi-sd-card-fill', tags: [] },
    { name: 'bi-sd-card', tags: [] },
    { name: 'bi-skype', tags: [] },
    { name: 'bi-slash-lg', tags: [] },
    { name: 'bi-translate', tags: [] },
    { name: 'bi-x-lg', tags: [] },
    { name: 'bi-safe', tags: [] },
    { name: 'bi-apple', tags: [] },
    { name: 'bi-microsoft', tags: [] },
    { name: 'bi-windows', tags: [] },
    { name: 'bi-behance', tags: [] },
    { name: 'bi-dribbble', tags: [] },
    { name: 'bi-line', tags: [] },
    { name: 'bi-medium', tags: [] },
    { name: 'bi-paypal', tags: [] },
    { name: 'bi-pinterest', tags: [] },
    { name: 'bi-signal', tags: [] },
    { name: 'bi-snapchat', tags: [] },
    { name: 'bi-spotify', tags: [] },
    { name: 'bi-stack-overflow', tags: [] },
    { name: 'bi-strava', tags: [] },
    { name: 'bi-wordpress', tags: [] },
    { name: 'bi-vimeo', tags: [] },
    { name: 'bi-activity', tags: [] },
    { name: 'bi-easel2-fill', tags: [] },
    { name: 'bi-easel2', tags: [] },
    { name: 'bi-easel3-fill', tags: [] },
    { name: 'bi-easel3', tags: [] },
    { name: 'bi-fan', tags: [] },
    { name: 'bi-fingerprint', tags: [] },
    { name: 'bi-graph-down-arrow', tags: [] },
    { name: 'bi-graph-up-arrow', tags: [] },
    { name: 'bi-hypnotize', tags: [] },
    { name: 'bi-magic', tags: [] },
    { name: 'bi-person-rolodex', tags: [] },
    { name: 'bi-person-video', tags: [] },
    { name: 'bi-person-video2', tags: [] },
    { name: 'bi-person-video3', tags: [] },
    { name: 'bi-person-workspace', tags: [] },
    { name: 'bi-radioactive', tags: [] },
    { name: 'bi-webcam-fill', tags: [] },
    { name: 'bi-webcam', tags: [] },
    { name: 'bi-yin-yang', tags: [] },
    { name: 'bi-bandaid-fill', tags: [] },
    { name: 'bi-bandaid', tags: [] },
    { name: 'bi-bluetooth', tags: [] },
    { name: 'bi-body-text', tags: [] },
    { name: 'bi-boombox', tags: [] },
    { name: 'bi-boxes', tags: [] },
    { name: 'bi-dpad-fill', tags: [] },
    { name: 'bi-dpad', tags: [] },
    { name: 'bi-ear-fill', tags: [] },
    { name: 'bi-ear', tags: [] },
    { name: 'bi-envelope-check-fill', tags: [] },
    { name: 'bi-envelope-check', tags: [] },
    { name: 'bi-envelope-dash-fill', tags: [] },
    { name: 'bi-envelope-dash', tags: [] },
    { name: 'bi-envelope-exclamation-fill', tags: [] },
    { name: 'bi-envelope-exclamation', tags: [] },
    { name: 'bi-envelope-plus-fill', tags: [] },
    { name: 'bi-envelope-plus', tags: [] },
    { name: 'bi-envelope-slash-fill', tags: [] },
    { name: 'bi-envelope-slash', tags: [] },
    { name: 'bi-envelope-x-fill', tags: [] },
    { name: 'bi-envelope-x', tags: [] },
    { name: 'bi-explicit-fill', tags: [] },
    { name: 'bi-explicit', tags: [] },
    { name: 'bi-git', tags: [] },
    { name: 'bi-infinity', tags: [] },
    { name: 'bi-list-columns-reverse', tags: [] },
    { name: 'bi-list-columns', tags: [] },
    { name: 'bi-meta', tags: [] },
    { name: 'bi-nintendo-switch', tags: [] },
    { name: 'bi-pc-display-horizontal', tags: [] },
    { name: 'bi-pc-display', tags: [] },
    { name: 'bi-pc-horizontal', tags: [] },
    { name: 'bi-pc', tags: [] },
    { name: 'bi-playstation', tags: [] },
    { name: 'bi-plus-slash-minus', tags: [] },
    { name: 'bi-projector-fill', tags: [] },
    { name: 'bi-projector', tags: [] },
    { name: 'bi-qr-code-scan', tags: [] },
    { name: 'bi-qr-code', tags: [] },
    { name: 'bi-quora', tags: [] },
    { name: 'bi-quote', tags: [] },
    { name: 'bi-robot', tags: [] },
    { name: 'bi-send-check-fill', tags: [] },
    { name: 'bi-send-check', tags: [] },
    { name: 'bi-send-dash-fill', tags: [] },
    { name: 'bi-send-dash', tags: [] },
    { name: 'bi-send-exclamation-fill', tags: [] },
    { name: 'bi-send-exclamation', tags: [] },
    { name: 'bi-send-fill', tags: [] },
    { name: 'bi-send-plus-fill', tags: [] },
    { name: 'bi-send-plus', tags: [] },
    { name: 'bi-send-slash-fill', tags: [] },
    { name: 'bi-send-slash', tags: [] },
    { name: 'bi-send-x-fill', tags: [] },
    { name: 'bi-send-x', tags: [] },
    { name: 'bi-send', tags: [] },
    { name: 'bi-steam', tags: [] },
    { name: 'bi-terminal-dash', tags: [] },
    { name: 'bi-terminal-plus', tags: [] },
    { name: 'bi-terminal-split', tags: [] },
    { name: 'bi-ticket-detailed-fill', tags: [] },
    { name: 'bi-ticket-detailed', tags: [] },
    { name: 'bi-ticket-fill', tags: [] },
    { name: 'bi-ticket-perforated-fill', tags: [] },
    { name: 'bi-ticket-perforated', tags: [] },
    { name: 'bi-ticket', tags: [] },
    { name: 'bi-tiktok', tags: [] },
    { name: 'bi-window-dash', tags: [] },
    { name: 'bi-window-desktop', tags: [] },
    { name: 'bi-window-fullscreen', tags: [] },
    { name: 'bi-window-plus', tags: [] },
    { name: 'bi-window-split', tags: [] },
    { name: 'bi-window-stack', tags: [] },
    { name: 'bi-window-x', tags: [] },
    { name: 'bi-xbox', tags: [] },
    { name: 'bi-ethernet', tags: [] },
    { name: 'bi-hdmi-fill', tags: [] },
    { name: 'bi-hdmi', tags: [] },
    { name: 'bi-usb-c-fill', tags: [] },
    { name: 'bi-usb-c', tags: [] },
    { name: 'bi-usb-fill', tags: [] },
    { name: 'bi-usb-plug-fill', tags: [] },
    { name: 'bi-usb-plug', tags: [] },
    { name: 'bi-usb-symbol', tags: [] },
    { name: 'bi-usb', tags: [] },
    { name: 'bi-boombox-fill', tags: [] },
    { name: 'bi-displayport', tags: [] },
    { name: 'bi-gpu-card', tags: [] },
    { name: 'bi-memory', tags: [] },
    { name: 'bi-modem-fill', tags: [] },
    { name: 'bi-modem', tags: [] },
    { name: 'bi-motherboard-fill', tags: [] },
    { name: 'bi-motherboard', tags: [] },
    { name: 'bi-optical-audio-fill', tags: [] },
    { name: 'bi-optical-audio', tags: [] },
    { name: 'bi-pci-card', tags: [] },
    { name: 'bi-router-fill', tags: [] },
    { name: 'bi-router', tags: [] },
    { name: 'bi-thunderbolt-fill', tags: [] },
    { name: 'bi-thunderbolt', tags: [] },
    { name: 'bi-usb-drive-fill', tags: [] },
    { name: 'bi-usb-drive', tags: [] },
    { name: 'bi-usb-micro-fill', tags: [] },
    { name: 'bi-usb-micro', tags: [] },
    { name: 'bi-usb-mini-fill', tags: [] },
    { name: 'bi-usb-mini', tags: [] },
    { name: 'bi-cloud-haze2', tags: [] },
    { name: 'bi-device-hdd-fill', tags: [] },
    { name: 'bi-device-hdd', tags: [] },
    { name: 'bi-device-ssd-fill', tags: [] },
    { name: 'bi-device-ssd', tags: [] },
    { name: 'bi-displayport-fill', tags: [] },
    { name: 'bi-mortarboard-fill', tags: [] },
    { name: 'bi-mortarboard', tags: [] },
    { name: 'bi-terminal-x', tags: [] },
    { name: 'bi-arrow-through-heart-fill', tags: [] },
    { name: 'bi-arrow-through-heart', tags: [] },
    { name: 'bi-badge-sd-fill', tags: [] },
    { name: 'bi-badge-sd', tags: [] },
    { name: 'bi-bag-heart-fill', tags: [] },
    { name: 'bi-bag-heart', tags: [] },
    { name: 'bi-balloon-fill', tags: [] },
    { name: 'bi-balloon-heart-fill', tags: [] },
    { name: 'bi-balloon-heart', tags: [] },
    { name: 'bi-balloon', tags: [] },
    { name: 'bi-box2-fill', tags: [] },
    { name: 'bi-box2-heart-fill', tags: [] },
    { name: 'bi-box2-heart', tags: [] },
    { name: 'bi-box2', tags: [] },
    { name: 'bi-braces-asterisk', tags: [] },
    { name: 'bi-calendar-heart-fill', tags: [] },
    { name: 'bi-calendar-heart', tags: [] },
    { name: 'bi-calendar2-heart-fill', tags: [] },
    { name: 'bi-calendar2-heart', tags: [] },
    { name: 'bi-chat-heart-fill', tags: [] },
    { name: 'bi-chat-heart', tags: [] },
    { name: 'bi-chat-left-heart-fill', tags: [] },
    { name: 'bi-chat-left-heart', tags: [] },
    { name: 'bi-chat-right-heart-fill', tags: [] },
    { name: 'bi-chat-right-heart', tags: [] },
    { name: 'bi-chat-square-heart-fill', tags: [] },
    { name: 'bi-chat-square-heart', tags: [] },
    { name: 'bi-clipboard-check-fill', tags: [] },
    { name: 'bi-clipboard-data-fill', tags: [] },
    { name: 'bi-clipboard-fill', tags: [] },
    { name: 'bi-clipboard-heart-fill', tags: [] },
    { name: 'bi-clipboard-heart', tags: [] },
    { name: 'bi-clipboard-minus-fill', tags: [] },
    { name: 'bi-clipboard-plus-fill', tags: [] },
    { name: 'bi-clipboard-pulse', tags: [] },
    { name: 'bi-clipboard-x-fill', tags: [] },
    { name: 'bi-clipboard2-check-fill', tags: [] },
    { name: 'bi-clipboard2-check', tags: [] },
    { name: 'bi-clipboard2-data-fill', tags: [] },
    { name: 'bi-clipboard2-data', tags: [] },
    { name: 'bi-clipboard2-fill', tags: [] },
    { name: 'bi-clipboard2-heart-fill', tags: [] },
    { name: 'bi-clipboard2-heart', tags: [] },
    { name: 'bi-clipboard2-minus-fill', tags: [] },
    { name: 'bi-clipboard2-minus', tags: [] },
    { name: 'bi-clipboard2-plus-fill', tags: [] },
    { name: 'bi-clipboard2-plus', tags: [] },
    { name: 'bi-clipboard2-pulse-fill', tags: [] },
    { name: 'bi-clipboard2-pulse', tags: [] },
    { name: 'bi-clipboard2-x-fill', tags: [] },
    { name: 'bi-clipboard2-x', tags: [] },
    { name: 'bi-clipboard2', tags: [] },
    { name: 'bi-emoji-kiss-fill', tags: [] },
    { name: 'bi-emoji-kiss', tags: [] },
    { name: 'bi-envelope-heart-fill', tags: [] },
    { name: 'bi-envelope-heart', tags: [] },
    { name: 'bi-envelope-open-heart-fill', tags: [] },
    { name: 'bi-envelope-open-heart', tags: [] },
    { name: 'bi-envelope-paper-fill', tags: [] },
    { name: 'bi-envelope-paper-heart-fill', tags: [] },
    { name: 'bi-envelope-paper-heart', tags: [] },
    { name: 'bi-envelope-paper', tags: [] },
    { name: 'bi-filetype-aac', tags: [] },
    { name: 'bi-filetype-ai', tags: [] },
    { name: 'bi-filetype-bmp', tags: [] },
    { name: 'bi-filetype-cs', tags: [] },
    { name: 'bi-filetype-css', tags: [] },
    { name: 'bi-filetype-csv', tags: [] },
    { name: 'bi-filetype-doc', tags: [] },
    { name: 'bi-filetype-docx', tags: [] },
    { name: 'bi-filetype-exe', tags: [] },
    { name: 'bi-filetype-gif', tags: [] },
    { name: 'bi-filetype-heic', tags: [] },
    { name: 'bi-filetype-html', tags: [] },
    { name: 'bi-filetype-java', tags: [] },
    { name: 'bi-filetype-jpg', tags: [] },
    { name: 'bi-filetype-js', tags: [] },
    { name: 'bi-filetype-jsx', tags: [] },
    { name: 'bi-filetype-key', tags: [] },
    { name: 'bi-filetype-m4p', tags: [] },
    { name: 'bi-filetype-md', tags: [] },
    { name: 'bi-filetype-mdx', tags: [] },
    { name: 'bi-filetype-mov', tags: [] },
    { name: 'bi-filetype-mp3', tags: [] },
    { name: 'bi-filetype-mp4', tags: [] },
    { name: 'bi-filetype-otf', tags: [] },
    { name: 'bi-filetype-pdf', tags: [] },
    { name: 'bi-filetype-php', tags: [] },
    { name: 'bi-filetype-png', tags: [] },
    { name: 'bi-filetype-ppt', tags: [] },
    { name: 'bi-filetype-psd', tags: [] },
    { name: 'bi-filetype-py', tags: [] },
    { name: 'bi-filetype-raw', tags: [] },
    { name: 'bi-filetype-rb', tags: [] },
    { name: 'bi-filetype-sass', tags: [] },
    { name: 'bi-filetype-scss', tags: [] },
    { name: 'bi-filetype-sh', tags: [] },
    { name: 'bi-filetype-svg', tags: [] },
    { name: 'bi-filetype-tiff', tags: [] },
    { name: 'bi-filetype-tsx', tags: [] },
    { name: 'bi-filetype-ttf', tags: [] },
    { name: 'bi-filetype-txt', tags: [] },
    { name: 'bi-filetype-wav', tags: [] },
    { name: 'bi-filetype-woff', tags: [] },
    { name: 'bi-filetype-xls', tags: [] },
    { name: 'bi-filetype-xml', tags: [] },
    { name: 'bi-filetype-yml', tags: [] },
    { name: 'bi-heart-arrow', tags: [] },
    { name: 'bi-heart-pulse-fill', tags: [] },
    { name: 'bi-heart-pulse', tags: [] },
    { name: 'bi-heartbreak-fill', tags: [] },
    { name: 'bi-heartbreak', tags: [] },
    { name: 'bi-hearts', tags: [] },
    { name: 'bi-hospital-fill', tags: [] },
    { name: 'bi-hospital', tags: [] },
    { name: 'bi-house-heart-fill', tags: [] },
    { name: 'bi-house-heart', tags: [] },
    { name: 'bi-incognito', tags: [] },
    { name: 'bi-magnet-fill', tags: [] },
    { name: 'bi-magnet', tags: [] },
    { name: 'bi-person-heart', tags: [] },
    { name: 'bi-person-hearts', tags: [] },
    { name: 'bi-phone-flip', tags: [] },
    { name: 'bi-plugin', tags: [] },
    { name: 'bi-postage-fill', tags: [] },
    { name: 'bi-postage-heart-fill', tags: [] },
    { name: 'bi-postage-heart', tags: [] },
    { name: 'bi-postage', tags: [] },
    { name: 'bi-postcard-fill', tags: [] },
    { name: 'bi-postcard-heart-fill', tags: [] },
    { name: 'bi-postcard-heart', tags: [] },
    { name: 'bi-postcard', tags: [] },
    { name: 'bi-search-heart-fill', tags: [] },
    { name: 'bi-search-heart', tags: [] },
    { name: 'bi-sliders2-vertical', tags: [] },
    { name: 'bi-sliders2', tags: [] },
    { name: 'bi-trash3-fill', tags: [] },
    { name: 'bi-trash3', tags: [] },
    { name: 'bi-valentine', tags: [] },
    { name: 'bi-valentine2', tags: [] },
    { name: 'bi-wrench-adjustable-circle-fill', tags: [] },
    { name: 'bi-wrench-adjustable-circle', tags: [] },
    { name: 'bi-wrench-adjustable', tags: [] },
    { name: 'bi-filetype-json', tags: [] },
    { name: 'bi-filetype-pptx', tags: [] },
    { name: 'bi-filetype-xlsx', tags: [] },
    { name: 'bi-1-circle-fill', tags: [] },
    { name: 'bi-1-circle', tags: [] },
    { name: 'bi-1-square-fill', tags: [] },
    { name: 'bi-1-square', tags: [] },
    { name: 'bi-2-circle-fill', tags: [] },
    { name: 'bi-2-circle', tags: [] },
    { name: 'bi-2-square-fill', tags: [] },
    { name: 'bi-2-square', tags: [] },
    { name: 'bi-3-circle-fill', tags: [] },
    { name: 'bi-3-circle', tags: [] },
    { name: 'bi-3-square-fill', tags: [] },
    { name: 'bi-3-square', tags: [] },
    { name: 'bi-4-circle-fill', tags: [] },
    { name: 'bi-4-circle', tags: [] },
    { name: 'bi-4-square-fill', tags: [] },
    { name: 'bi-4-square', tags: [] },
    { name: 'bi-5-circle-fill', tags: [] },
    { name: 'bi-5-circle', tags: [] },
    { name: 'bi-5-square-fill', tags: [] },
    { name: 'bi-5-square', tags: [] },
    { name: 'bi-6-circle-fill', tags: [] },
    { name: 'bi-6-circle', tags: [] },
    { name: 'bi-6-square-fill', tags: [] },
    { name: 'bi-6-square', tags: [] },
    { name: 'bi-7-circle-fill', tags: [] },
    { name: 'bi-7-circle', tags: [] },
    { name: 'bi-7-square-fill', tags: [] },
    { name: 'bi-7-square', tags: [] },
    { name: 'bi-8-circle-fill', tags: [] },
    { name: 'bi-8-circle', tags: [] },
    { name: 'bi-8-square-fill', tags: [] },
    { name: 'bi-8-square', tags: [] },
    { name: 'bi-9-circle-fill', tags: [] },
    { name: 'bi-9-circle', tags: [] },
    { name: 'bi-9-square-fill', tags: [] },
    { name: 'bi-9-square', tags: [] },
    { name: 'bi-airplane-engines-fill', tags: [] },
    { name: 'bi-airplane-engines', tags: [] },
    { name: 'bi-airplane-fill', tags: [] },
    { name: 'bi-airplane', tags: [] },
    { name: 'bi-alexa', tags: [] },
    { name: 'bi-alipay', tags: [] },
    { name: 'bi-android', tags: [] },
    { name: 'bi-android2', tags: [] },
    { name: 'bi-box-fill', tags: [] },
    { name: 'bi-box-seam-fill', tags: [] },
    { name: 'bi-browser-chrome', tags: [] },
    { name: 'bi-browser-edge', tags: [] },
    { name: 'bi-browser-firefox', tags: [] },
    { name: 'bi-browser-safari', tags: [] },
    { name: 'bi-c-circle-fill', tags: [] },
    { name: 'bi-c-circle', tags: [] },
    { name: 'bi-c-square-fill', tags: [] },
    { name: 'bi-c-square', tags: [] },
    { name: 'bi-capsule-pill', tags: [] },
    { name: 'bi-capsule', tags: [] },
    { name: 'bi-car-front-fill', tags: [] },
    { name: 'bi-car-front', tags: [] },
    { name: 'bi-cassette-fill', tags: [] },
    { name: 'bi-cassette', tags: [] },
    { name: 'bi-cc-circle-fill', tags: [] },
    { name: 'bi-cc-circle', tags: [] },
    { name: 'bi-cc-square-fill', tags: [] },
    { name: 'bi-cc-square', tags: [] },
    { name: 'bi-cup-hot-fill', tags: [] },
    { name: 'bi-cup-hot', tags: [] },
    { name: 'bi-currency-rupee', tags: [] },
    { name: 'bi-dropbox', tags: [] },
    { name: 'bi-escape', tags: [] },
    { name: 'bi-fast-forward-btn-fill', tags: [] },
    { name: 'bi-fast-forward-btn', tags: [] },
    { name: 'bi-fast-forward-circle-fill', tags: [] },
    { name: 'bi-fast-forward-circle', tags: [] },
    { name: 'bi-fast-forward-fill', tags: [] },
    { name: 'bi-fast-forward', tags: [] },
    { name: 'bi-filetype-sql', tags: [] },
    { name: 'bi-fire', tags: [] },
    { name: 'bi-google-play', tags: [] },
    { name: 'bi-h-circle-fill', tags: [] },
    { name: 'bi-h-circle', tags: [] },
    { name: 'bi-h-square-fill', tags: [] },
    { name: 'bi-h-square', tags: [] },
    { name: 'bi-indent', tags: [] },
    { name: 'bi-lungs-fill', tags: [] },
    { name: 'bi-lungs', tags: [] },
    { name: 'bi-microsoft-teams', tags: [] },
    { name: 'bi-p-circle-fill', tags: [] },
    { name: 'bi-p-circle', tags: [] },
    { name: 'bi-p-square-fill', tags: [] },
    { name: 'bi-p-square', tags: [] },
    { name: 'bi-pass-fill', tags: [] },
    { name: 'bi-pass', tags: [] },
    { name: 'bi-prescription', tags: [] },
    { name: 'bi-prescription2', tags: [] },
    { name: 'bi-r-circle-fill', tags: [] },
    { name: 'bi-r-circle', tags: [] },
    { name: 'bi-r-square-fill', tags: [] },
    { name: 'bi-r-square', tags: [] },
    { name: 'bi-repeat-1', tags: [] },
    { name: 'bi-repeat', tags: [] },
    { name: 'bi-rewind-btn-fill', tags: [] },
    { name: 'bi-rewind-btn', tags: [] },
    { name: 'bi-rewind-circle-fill', tags: [] },
    { name: 'bi-rewind-circle', tags: [] },
    { name: 'bi-rewind-fill', tags: [] },
    { name: 'bi-rewind', tags: [] },
    { name: 'bi-train-freight-front-fill', tags: [] },
    { name: 'bi-train-freight-front', tags: [] },
    { name: 'bi-train-front-fill', tags: [] },
    { name: 'bi-train-front', tags: [] },
    { name: 'bi-train-lightrail-front-fill', tags: [] },
    { name: 'bi-train-lightrail-front', tags: [] },
    { name: 'bi-truck-front-fill', tags: [] },
    { name: 'bi-truck-front', tags: [] },
    { name: 'bi-ubuntu', tags: [] },
    { name: 'bi-unindent', tags: [] },
    { name: 'bi-unity', tags: [] },
    { name: 'bi-universal-access-circle', tags: [] },
    { name: 'bi-universal-access', tags: [] },
    { name: 'bi-virus', tags: [] },
    { name: 'bi-virus2', tags: [] },
    { name: 'bi-wechat', tags: [] },
    { name: 'bi-yelp', tags: [] },
    { name: 'bi-sign-stop-fill', tags: [] },
    { name: 'bi-sign-stop-lights-fill', tags: [] },
    { name: 'bi-sign-stop-lights', tags: [] },
    { name: 'bi-sign-stop', tags: [] },
    { name: 'bi-sign-turn-left-fill', tags: [] },
    { name: 'bi-sign-turn-left', tags: [] },
    { name: 'bi-sign-turn-right-fill', tags: [] },
    { name: 'bi-sign-turn-right', tags: [] },
    { name: 'bi-sign-turn-slight-left-fill', tags: [] },
    { name: 'bi-sign-turn-slight-left', tags: [] },
    { name: 'bi-sign-turn-slight-right-fill', tags: [] },
    { name: 'bi-sign-turn-slight-right', tags: [] },
    { name: 'bi-sign-yield-fill', tags: [] },
    { name: 'bi-sign-yield', tags: [] },
    { name: 'bi-ev-station-fill', tags: [] },
    { name: 'bi-ev-station', tags: [] },
    { name: 'bi-fuel-pump-diesel-fill', tags: [] },
    { name: 'bi-fuel-pump-diesel', tags: [] },
    { name: 'bi-fuel-pump-fill', tags: [] },
    { name: 'bi-fuel-pump', tags: [] },
    { name: 'bi-0-circle-fill', tags: [] },
    { name: 'bi-0-circle', tags: [] },
    { name: 'bi-0-square-fill', tags: [] },
    { name: 'bi-0-square', tags: [] },
    { name: 'bi-rocket-fill', tags: [] },
    { name: 'bi-rocket-takeoff-fill', tags: [] },
    { name: 'bi-rocket-takeoff', tags: [] },
    { name: 'bi-rocket', tags: [] },
    { name: 'bi-stripe', tags: [] },
    { name: 'bi-subscript', tags: [] },
    { name: 'bi-superscript', tags: [] },
    { name: 'bi-trello', tags: [] },
    { name: 'bi-envelope-at-fill', tags: [] },
    { name: 'bi-envelope-at', tags: [] },
    { name: 'bi-regex', tags: [] },
    { name: 'bi-text-wrap', tags: [] },
    { name: 'bi-sign-dead-end-fill', tags: [] },
    { name: 'bi-sign-dead-end', tags: [] },
    { name: 'bi-sign-do-not-enter-fill', tags: [] },
    { name: 'bi-sign-do-not-enter', tags: [] },
    { name: 'bi-sign-intersection-fill', tags: [] },
    { name: 'bi-sign-intersection-side-fill', tags: [] },
    { name: 'bi-sign-intersection-side', tags: [] },
    { name: 'bi-sign-intersection-t-fill', tags: [] },
    { name: 'bi-sign-intersection-t', tags: [] },
    { name: 'bi-sign-intersection-y-fill', tags: [] },
    { name: 'bi-sign-intersection-y', tags: [] },
    { name: 'bi-sign-intersection', tags: [] },
    { name: 'bi-sign-merge-left-fill', tags: [] },
    { name: 'bi-sign-merge-left', tags: [] },
    { name: 'bi-sign-merge-right-fill', tags: [] },
    { name: 'bi-sign-merge-right', tags: [] },
    { name: 'bi-sign-no-left-turn-fill', tags: [] },
    { name: 'bi-sign-no-left-turn', tags: [] },
    { name: 'bi-sign-no-parking-fill', tags: [] },
    { name: 'bi-sign-no-parking', tags: [] },
    { name: 'bi-sign-no-right-turn-fill', tags: [] },
    { name: 'bi-sign-no-right-turn', tags: [] },
    { name: 'bi-sign-railroad-fill', tags: [] },
    { name: 'bi-sign-railroad', tags: [] },
    { name: 'bi-building-add', tags: [] },
    { name: 'bi-building-check', tags: [] },
    { name: 'bi-building-dash', tags: [] },
    { name: 'bi-building-down', tags: [] },
    { name: 'bi-building-exclamation', tags: [] },
    { name: 'bi-building-fill-add', tags: [] },
    { name: 'bi-building-fill-check', tags: [] },
    { name: 'bi-building-fill-dash', tags: [] },
    { name: 'bi-building-fill-down', tags: [] },
    { name: 'bi-building-fill-exclamation', tags: [] },
    { name: 'bi-building-fill-gear', tags: [] },
    { name: 'bi-building-fill-lock', tags: [] },
    { name: 'bi-building-fill-slash', tags: [] },
    { name: 'bi-building-fill-up', tags: [] },
    { name: 'bi-building-fill-x', tags: [] },
    { name: 'bi-building-fill', tags: [] },
    { name: 'bi-building-gear', tags: [] },
    { name: 'bi-building-lock', tags: [] },
    { name: 'bi-building-slash', tags: [] },
    { name: 'bi-building-up', tags: [] },
    { name: 'bi-building-x', tags: [] },
    { name: 'bi-buildings-fill', tags: [] },
    { name: 'bi-buildings', tags: [] },
    { name: 'bi-bus-front-fill', tags: [] },
    { name: 'bi-bus-front', tags: [] },
    { name: 'bi-ev-front-fill', tags: [] },
    { name: 'bi-ev-front', tags: [] },
    { name: 'bi-globe-americas', tags: [] },
    { name: 'bi-globe-asia-australia', tags: [] },
    { name: 'bi-globe-central-south-asia', tags: [] },
    { name: 'bi-globe-europe-africa', tags: [] },
    { name: 'bi-house-add-fill', tags: [] },
    { name: 'bi-house-add', tags: [] },
    { name: 'bi-house-check-fill', tags: [] },
    { name: 'bi-house-check', tags: [] },
    { name: 'bi-house-dash-fill', tags: [] },
    { name: 'bi-house-dash', tags: [] },
    { name: 'bi-house-down-fill', tags: [] },
    { name: 'bi-house-down', tags: [] },
    { name: 'bi-house-exclamation-fill', tags: [] },
    { name: 'bi-house-exclamation', tags: [] },
    { name: 'bi-house-gear-fill', tags: [] },
    { name: 'bi-house-gear', tags: [] },
    { name: 'bi-house-lock-fill', tags: [] },
    { name: 'bi-house-lock', tags: [] },
    { name: 'bi-house-slash-fill', tags: [] },
    { name: 'bi-house-slash', tags: [] },
    { name: 'bi-house-up-fill', tags: [] },
    { name: 'bi-house-up', tags: [] },
    { name: 'bi-house-x-fill', tags: [] },
    { name: 'bi-house-x', tags: [] },
    { name: 'bi-person-add', tags: [] },
    { name: 'bi-person-down', tags: [] },
    { name: 'bi-person-exclamation', tags: [] },
    { name: 'bi-person-fill-add', tags: [] },
    { name: 'bi-person-fill-check', tags: [] },
    { name: 'bi-person-fill-dash', tags: [] },
    { name: 'bi-person-fill-down', tags: [] },
    { name: 'bi-person-fill-exclamation', tags: [] },
    { name: 'bi-person-fill-gear', tags: [] },
    { name: 'bi-person-fill-lock', tags: [] },
    { name: 'bi-person-fill-slash', tags: [] },
    { name: 'bi-person-fill-up', tags: [] },
    { name: 'bi-person-fill-x', tags: [] },
    { name: 'bi-person-gear', tags: [] },
    { name: 'bi-person-lock', tags: [] },
    { name: 'bi-person-slash', tags: [] },
    { name: 'bi-person-up', tags: [] },
    { name: 'bi-scooter', tags: [] },
    { name: 'bi-taxi-front-fill', tags: [] },
    { name: 'bi-taxi-front', tags: [] },
    { name: 'bi-amd', tags: [] },
    { name: 'bi-database-add', tags: [] },
    { name: 'bi-database-check', tags: [] },
    { name: 'bi-database-dash', tags: [] },
    { name: 'bi-database-down', tags: [] },
    { name: 'bi-database-exclamation', tags: [] },
    { name: 'bi-database-fill-add', tags: [] },
    { name: 'bi-database-fill-check', tags: [] },
    { name: 'bi-database-fill-dash', tags: [] },
    { name: 'bi-database-fill-down', tags: [] },
    { name: 'bi-database-fill-exclamation', tags: [] },
    { name: 'bi-database-fill-gear', tags: [] },
    { name: 'bi-database-fill-lock', tags: [] },
    { name: 'bi-database-fill-slash', tags: [] },
    { name: 'bi-database-fill-up', tags: [] },
    { name: 'bi-database-fill-x', tags: [] },
    { name: 'bi-database-fill', tags: [] },
    { name: 'bi-database-gear', tags: [] },
    { name: 'bi-database-lock', tags: [] },
    { name: 'bi-database-slash', tags: [] },
    { name: 'bi-database-up', tags: [] },
    { name: 'bi-database-x', tags: [] },
    { name: 'bi-database', tags: [] },
    { name: 'bi-houses-fill', tags: [] },
    { name: 'bi-houses', tags: [] },
    { name: 'bi-nvidia', tags: [] },
    { name: 'bi-person-vcard-fill', tags: [] },
    { name: 'bi-person-vcard', tags: [] },
    { name: 'bi-sina-weibo', tags: [] },
    { name: 'bi-tencent-qq', tags: [] },
    { name: 'bi-wikipedia', tags: [] }
  ]
}
